import {
  Box,
  Grid,
  Paper,
  Theme,
  Toolbar,
  Dialog,
  Button,
  SvgIcon,
  Typography,
  useMediaQuery,
  Snackbar,
  Divider,
  Link,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
} from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { useGridApiRef, GridPreferencePanelsValue } from '@mui/x-data-grid-pro';
import { useTheme } from '@mui/material/styles';
import RefreshIcon from '@mui/icons-material/Refresh';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import MailIcon from '@mui/icons-material/Mail';
import ForwardToInbox from '@mui/icons-material/ForwardToInbox';
import AddIcon from '@mui/icons-material/AddCircle';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CheckIcon from '@mui/icons-material/Check';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import React, { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router-dom';
import PaymentRequestList from '../../components/PaymentRequestList';
import TabPanel from '../../components/TabPanel';
import IssueRefundPayment from '../../components/IssueRefundPayment';
import {
  OrderDirection,
  PaymentRequestOrder,
  PaymentRequestOrderField,
  PaymentRequest,
  PaymentRequestStatus,
  Payment,
  PaymentOrder,
  PaymentOrderField,
  PaymentStatus,
  RefundStatus,
  CommunicationType,
  FileFormat,
  CompanyVerificationStatus,
  PaymentStatusExtended,
  AppRole,
  PaymentRequestForwardInput,
  TransitionStatus,
  PayFac,
  PaymentMethodType,
  SettlementStatus,
  DateRangeType,
} from '../../gql-types.generated';
import { checkPermission, Permission } from '../../util/RoleCheck';
import {
  selectNetworkBusy,
  selectTenantId,
  selectViewerUser,
  selectTenantAccount,
  selectDefaultCurrency,
  fetchPendingBannerVisible,
  selectPendingBannerVisible,
  selectPaymentRequestsFeatures,
  selectPaymentRequestSuccessMessage,
} from '../app/AppSlice';
import {
  refund,
  voidPayment,
  fetchPaymentRequestList,
  remindPaymentRequest,
  closeOrCompletePaymentRequest,
  fetchPaymentList,
  updatePaymentRequest,
  fetchPaymentById,
  createPaymentsReport,
  fetchPaymentRequestById,
  fetchPaymentRequestByIdAfterUpdate,
  resendPaymentReceipt,
  remindPaymentRequests,
  forwardPaymentRequest,
} from './HomeActions';
import {
  clearRefundStatus,
  clearVoidStatus,
  captureVoidError,
  captureVoidErrorReasonCode,
  selectPaymentRequestConnection,
  captureSearchError,
  selectRefundStatus,
  selectVoidStatus,
  selectVoidError,
  selectVoidErrorReasonCode,
  selectSearchError,
  selectPaymentRequests,
  selectReminderStatus,
  clearReminderStatus,
  selectVerificationStatus,
  clearVerificationStatus,
  selectIsLoadingPaymentRequests,
  selectRefundIdempotencyKey,
  fetchRefundIdempotencyKey,
  selectPaymentConnection,
  selectPayments,
  selectPaymentSearch,
  capturePaymentRequestSearch,
  capturePaymentSearch,
  selectIsLoadingPayments,
  fetchIsPaymentRefunded,
  fetchPaymentRefundedAmount,
  clearUpdatePaymentRequestStatus,
  selectUpdatePaymentRequestStatus,
  clearUpdatePaymentRequestError,
  selectUpdatePaymentRequestError,
  selectPaymentById,
  selectPaymentByIdError,
  capturePaymentByIdError,
  capturePaymentById,
  captureRefundError,
  selectRefundError,
  selectPaymentsReport,
  selectPaymentsReportError,
  capturePaymentsReport,
  capturePaymentsReportError,
  selectPaymentRequestById,
  selectPaymentRequestByIdError,
  capturePaymentRequestById,
  capturePaymentRequestByIdError,
  fetchHasAdditionalBanner,
  selectHasAdditionalBanner,
  captureCloseOrCompleteError,
  selectCloseOrCompleteError,
  selectPaymentRequestByIdAfterUpdate,
  selectPaymentRequestByIdAfterUpdateError,
  capturePaymentRequestByIdAfterUpdate,
  capturePaymentRequestByIdAfterUpdateError,
  selectIsPaymentListInFlight,
  selectIsPaymentRequestListInFlight,
  selectResendingPaymentReceipt,
  selectIsPaymentReceiptResent,
  fetchIsPaymentReceiptResent,
  selectResendPaymentReceiptError,
  fetchResendPaymentReceiptError,
  selectPaymentFilterCustomerOption,
  selectPaymentRequestFilterCustomerOption,
  selectPaymentFilterDateOption,
  selectPaymentFilterFromDate,
  selectPaymentFilterToDate,
  selectPaymentFilterFromAmount,
  selectPaymentFilterToAmount,
  selectPaymentFilterAmountRange,
  fetchPaymentFilterDateOption,
  fetchPaymentFilterCustomerOption,
  fetchPaymentFilterFromDate,
  fetchPaymentFilterToDate,
  fetchPaymentFilterAmountRange,
  fetchPaymentFilterFromAmount,
  fetchPaymentFilterToAmount,
  selectPaymentFilterStatusCount,
  selectPaymentRequestFilterStatusCount,
  selectPaymentFilterStatusList,
  selectPaymentRequestFilterStatusList,
  fetchPaymentFilterStatusList,
  fetchPaymentFilterStatusCount,
  fetchAllPaymentsStatusList,
  selectAllPaymentsStatusList,
  fetchAllPaymentRequestStatusList,
  selectAllPaymentRequestStatusList,
  fetchReloadPaymentsAfterFilter,
  selectReloadPaymentsAfterFilter,
  fetchReloadPaymentRequestsAfterFilter,
  fetchAllPaymentsStatusExtendedList,
  selectReloadPaymentRequestsAfterFilter,
  selectAllPaymentsStatusExtendedList,
  selectCustomerOptionError,
  fetchPaymentRequestFilterStatusCount,
  fetchPaymentRequestFilterStatusList,
  fetchPaymentRequestFilterCustomerOption,
  selectRemindPaymentRequestsSuccessCount,
  selectIsRemindPaymentRequestsInFlight,
  fetchRemindPaymentRequestsSuccessCount,
  selectForwardPaymentRequestError,
  captureForwardPaymentRequestError,
  selectForwardPaymentRequestSuccess,
  captureForwardPaymentRequestSucccess,
  fetchLastTabPath,
  selectGeneratingExportInFlight,
  captureExportsCancelledInFlight,
  selectPaymentRequestSearch,
  selectPaymentFilterPaymentMethodOption,
  fetchPaymentFilterPaymentMethodOption,
  selectPaymentFilterPaymentMethodType,
  fetchPaymentFilterPaymentMethodType,
} from './HomeSlice';
import IssueRefund from '../../components/IssueRefund';
import VoidPayment from '../../components/VoidPayment';
import { ReactComponent as RefundIcon } from '../../refund.svg';
import PaymentRequestDetails from '../../components/PaymentRequestDetails';
import PaymentsList from '../../components/PaymentsList';
import PaymentDetails from '../../components/PaymentDetails';
import { v4 as uuid4 } from 'uuid';
import ExportPayments, { truncatedExportMessage } from '../../components/ExportPayments';
import LoadingMask from '../../components/LoadingMask';
import { ReactComponent as FileDownloadIcon } from '../../FileDownload.svg';
import { Alert } from '@mui/lab';
import AccountPendingBanner from '../../components/AccountPendingBanner';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PaymentsListFilter from '../../components/PaymentsListFilter';
import PaymentRequestListFilter from '../../components/PaymentRequestListFilter';
import PaymentsListFilterChips from '../../components/PaymentsListFilterChips';
import PaymentRequestListFilterChips from '../../components/PaymentRequestListFilterChips';
import { AllPaymentStatusFilterValue, MAX_STATUS_COUNT } from '../../util/PaymentsListFilterValue';
import {
  AllPaymentRequestsStatusFilterValue,
  MAX_STATUS_COUNT as PR_MAX_STATUS_COUNT,
} from '../../util/PaymentRequestsListFilterValue';
import SearchBar from '../../components/SearchBar';
import ForwardDialog from '../../components/ForwardDialog';
import { CustomerOption } from '../../custom-types/CustomerOption';
import { PaymentMethodOption } from '../../custom-types/PaymentMethodOption';
import { PaymentsExportFilter } from '../../custom-types/PaymentsExportFilter';
import { DateTime } from 'luxon';
import {
  fetchCreatePaymentSuccessMessage,
  fetchRequestsToPay,
  selectCreatePaymentSuccessMessage,
} from '../virtual-terminal/PaymentVirtualTerminalSlice';
import { RoutePath } from '../../util/Routes';
import { Helmet } from 'react-helmet';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    rootContainer: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      minWidth: 0,
      [theme.breakpoints.down('sm')]: {
        padding: 0,
      },
    },
    root: {
      flexGrow: 2,
    },
    pageTitle: {
      textAlign: 'start',
      padding: theme.spacing(2, 1, 1.5, 3),
    },
    loadingGridItem: {
      width: 100,
      paddingTop: theme.spacing(2),
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    tabs: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      flexGrow: 1,
      minWidth: 0,

      '& [role="tabpanel"]': {
        flex: 1,
        minWidth: 0,

        '& > .MuiBox-root': {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
        },
      },
    },
    title: {
      flex: '1',
      textAlign: 'left',
    },
    selectedTab: {
      borderBottomWidth: 0,
      backgroundColor: theme.palette.uxBlue.activated,
    },
    tabRoot: {
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      color: theme.palette.primary.main,
      borderBottomColor: theme.palette.uxGrey.focus,
    },
    tabToolbar: {
      padding: theme.spacing(0.5, 0.5),
    },
    toolbarButton: {
      marginLeft: 0,
      margin: theme.spacing(1, 0),
      padding: theme.spacing(0.5, 1.5),
      minWidth: 'auto',
      [theme.breakpoints.down('xs')]: {
        minWidth: 40,
        minHeight: 48,
        marginRight: 0,
        padding: 0,
      },
    },
    transition: {
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    snackBar: {
      minWidth: '100%',
      justifyContent: 'center',
    },
    snackBarMobile: {
      minWidth: '100%',
      justifyContent: 'center',
      left: 0,
      right: 0,
      bottom: 0,
    },
    snackBarAlert: {
      minWidth: '100%',
      justifyContent: 'center',
      fontWeight: 500,
      color: theme.palette.success.main,
    },
    snackBarErrorAlert: {
      minWidth: '100%',
      justifyContent: 'center',
      fontWeight: 500,
      color: theme.palette.error.main,
    },
    snackBarWarningAlert: {
      minWidth: '100%',
      justifyContent: 'center',
      fontWeight: 500,
      backgroundColor: theme.palette.warning.light,
    },
    snackBarInfoAlert: {
      minWidth: '100%',
      justifyContent: 'center',
      fontWeight: 500,
    },
    warningAlertText: {
      fontSize: 16,
      color: theme.palette.warning.dark,
    },
    errorAlertText: {
      fontSize: 16,
    },
  }),
);
interface HomeProps {
  tabPath: string;
}

// How long a payment paid entirely with credit stays voidable. Must match CREDIT_ONLY_VOID_WINDOW_HOURS in
// ezpay-api-svc PaymentsService, which refuses the void after it regardless.
const creditOnlyVoidWindowMs = 24 * 60 * 60 * 1000;

const Home: React.FC<HomeProps> = (props: HomeProps) => {
  const { tabPath } = props;
  const classes = useStyles();
  const theme = useTheme();
  const tenantId = useSelector(selectTenantId);
  const user = useSelector(selectViewerUser);
  const tenantAccount = useSelector(selectTenantAccount);
  const networkBusy = useSelector(selectNetworkBusy);
  const paymentRequestQueryString = useSelector(selectPaymentRequestSearch);
  const payRequestConnection = useSelector(selectPaymentRequestConnection);
  const paymentRequests = useSelector(selectPaymentRequests);
  const defaultCurrency = useSelector(selectDefaultCurrency);
  const refundStatus = useSelector(selectRefundStatus);
  const voidStatus = useSelector(selectVoidStatus);
  const voidError = useSelector(selectVoidError);
  const voidErrorReasonCode = useSelector(selectVoidErrorReasonCode);
  const reminderStatus = useSelector(selectReminderStatus);
  const isLoadingPaymentRequests = useSelector(selectIsLoadingPaymentRequests);
  const searchError = useSelector(selectSearchError);
  const verificationStatus = useSelector(selectVerificationStatus);
  const refundIdempotencyKey = useSelector(selectRefundIdempotencyKey);
  const paymentConnection = useSelector(selectPaymentConnection);
  const payments = useSelector(selectPayments);
  const paymentQueryString = useSelector(selectPaymentSearch);
  const isLoadingPayments = useSelector(selectIsLoadingPayments);
  const updatePaymentRequestStatus = useSelector(selectUpdatePaymentRequestStatus);
  const updatePaymentRequestError = useSelector(selectUpdatePaymentRequestError);
  const paymentById = useSelector(selectPaymentById);
  const refundError = useSelector(selectRefundError);
  const paymentByIdError = useSelector(selectPaymentByIdError);
  const paymentRequestById = useSelector(selectPaymentRequestById);
  const paymentRequestByIdError = useSelector(selectPaymentRequestByIdError);
  const paymentsReport = useSelector(selectPaymentsReport);
  const paymentsReportError = useSelector(selectPaymentsReportError);
  const hasAdditionalBanner = useSelector(selectHasAdditionalBanner);
  const pendingBannerVisible = useSelector(selectPendingBannerVisible);
  const closeOrCompleteError = useSelector(selectCloseOrCompleteError);
  const paymentRequestByIdAfterUpdate = useSelector(selectPaymentRequestByIdAfterUpdate);
  const paymentRequestByIdAfterUpdateError = useSelector(selectPaymentRequestByIdAfterUpdateError);
  const isPaymentListInFlight = useSelector(selectIsPaymentListInFlight);
  const isPaymentRequestListInFlight = useSelector(selectIsPaymentRequestListInFlight);
  const isResendingPaymentReceipt = useSelector(selectResendingPaymentReceipt);
  const isPaymentReceiptResent = useSelector(selectIsPaymentReceiptResent);
  const resendPaymentReceiptError = useSelector(selectResendPaymentReceiptError);
  const paymentFilterCustomerOption = useSelector(selectPaymentFilterCustomerOption);
  const paymentRequestFilterCustomerOption = useSelector(selectPaymentRequestFilterCustomerOption);
  const paymentFilterPaymentMethodOption = useSelector(selectPaymentFilterPaymentMethodOption);
  const paymentFilterPaymentMethodType = useSelector(selectPaymentFilterPaymentMethodType);
  const paymentFilterDateOption = useSelector(selectPaymentFilterDateOption);
  const paymentFilterFromDate = useSelector(selectPaymentFilterFromDate);
  const paymentFilterToDate = useSelector(selectPaymentFilterToDate);
  const paymentFilterAmountRange = useSelector(selectPaymentFilterAmountRange);
  const paymentFilterFromAmount = useSelector(selectPaymentFilterFromAmount);
  const paymentFilterToAmount = useSelector(selectPaymentFilterToAmount);
  const paymentFilterStatusCount = useSelector(selectPaymentFilterStatusCount);
  const paymentFilterStatusList = useSelector(selectPaymentFilterStatusList);
  const allPaymentsStatusList = useSelector(selectAllPaymentsStatusList);
  const allPaymentsStatusExtendedList = useSelector(selectAllPaymentsStatusExtendedList);
  const paymentRequestFilterStatusCount = useSelector(selectPaymentRequestFilterStatusCount);
  const paymentRequestFilterStatusList = useSelector(selectPaymentRequestFilterStatusList);
  const allPaymentRequestStatusList = useSelector(selectAllPaymentRequestStatusList);
  const reloadPaymentsAfterFilter = useSelector(selectReloadPaymentsAfterFilter);
  const reloadPaymentRequestsAfterFilter = useSelector(selectReloadPaymentRequestsAfterFilter);
  const customerOptionError = useSelector(selectCustomerOptionError);
  const remindPaymentRequestsSuccessCount = useSelector(selectRemindPaymentRequestsSuccessCount);
  const isRemindPaymentRequestsInFlight = useSelector(selectIsRemindPaymentRequestsInFlight);
  const forwardPaymentRequestError = useSelector(selectForwardPaymentRequestError);
  const forwardPaymentRequestSuccess = useSelector(selectForwardPaymentRequestSuccess);
  const paymentRequestFeatures = useSelector(selectPaymentRequestsFeatures);
  const createPaymentSuccessMessage = useSelector(selectCreatePaymentSuccessMessage);
  const paymentRequestSuccessMessage = useSelector(selectPaymentRequestSuccessMessage);
  const generatingExportsInFlight = useSelector(selectGeneratingExportInFlight);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [remindDisabled, setRemindDisabled] = useState(false);
  const [refundDialogOpen, setRefundDialogOpen] = useState(false);
  const [paymentRefundDialogOpen, setPaymentRefundDialogOpen] = useState(false);
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [paymentDetailsDialogOpen, setPaymentDetailsDialogOpen] = useState(false);
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  // A "direct" export is one started from the toolbar without the dialog, so this view - not the
  // dialog - owns its progress, its finished file and its error.
  const [directExportInFlight, setDirectExportInFlight] = useState(false);
  const [directExportError, setDirectExportError] = useState<Error>();
  const [selectedPaymentRequests, setSelectedPaymentRequests] = useState<PaymentRequest[] | undefined>();
  const [selectedPayment, setSelectedPayment] = useState<Payment | undefined>();
  const [displayChallengeSuccessful, setDisplayChallengeSuccessful] = useState(false);
  const [displayForwardPaymentRequestSuccessful, setDisplayForwardPaymentRequestSuccessful] = useState(false);
  const [forwardPaymentRequestSuccessMessage, setForwardPaymentRequestSuccessMessage] = useState<string>('');
  const [paymentRequestOrder, setPaymentRequestOrder] = useState<PaymentRequestOrder>({
    direction: OrderDirection.Desc,
    field: PaymentRequestOrderField.Timestamp,
  });
  const [paymentOrder, setPaymentOrder] = useState<PaymentOrder>({
    direction: OrderDirection.Desc,
    field: PaymentOrderField.Timestamp,
  });
  const getTabValue = () => {
    switch (tabPath) {
      case RoutePath.Requests:
        return 1;
      case RoutePath.Payments:
      default:
        return 0;
    }
  };
  const [activeViewPaymentRequestRecord, setActiveViewPaymentRequestRecord] = useState<PaymentRequest | undefined>();
  const [activeRefundPaymentRequestRecord, setActiveRefundPaymentRequestRecord] = useState<PaymentRequest | undefined>();
  const [activeIssueRefundPaymentRecord, setActiveIssueRefundPaymentRecord] = useState<Payment | undefined>();
  const [voidDialogOpen, setVoidDialogOpen] = useState(false);
  const [activeVoidPaymentRecord, setActiveVoidPaymentRecord] = useState<Payment | undefined>();
  const [activeViewPaymentRecord, setActiveViewPaymentRecord] = useState<Payment | undefined>();
  const [activeRefundPaymentRecord, setActiveRefundPaymentRecord] = useState<Payment | undefined>();
  const [tabValue, setTabValue] = useState(getTabValue());
  const [paymentRequestDirection, setPaymentRequestDirection] = useState<OrderDirection>(OrderDirection.Desc);
  const [paymentDirection, setPaymentDirection] = useState<OrderDirection>(OrderDirection.Desc);
  const [paymentRequestField, setPaymentRequestField] = useState<PaymentRequestOrderField>(PaymentRequestOrderField.Timestamp);
  const [paymentField, setPaymentField] = useState<PaymentOrderField>(PaymentOrderField.Timestamp);
  const [isCloseOrCompleteWaiting, setIsCloseOrCompleteWaiting] = useState<boolean>(false);
  const [updatePaymentRequestDisabled, setUpdatePaymentRequestDisabled] = useState<boolean>(false);
  const [isHistoryDetailClicked, setIsHistoryDetailClicked] = useState<boolean>(false);
  const [isInvoiceDetailClicked, setIsInvoiceDetailClicked] = useState<boolean>(false);
  const [isInvoiceRefundClicked, setIsInvoiceRefundClicked] = useState<boolean>(false);
  const [isRefundRequestClicked, setIsRefundRequestClicked] = useState<boolean>(false);
  const [isClosingPaymentRequest, setIsClosingPaymentRequest] = useState<boolean>(false);
  const [isCompletingPaymentRequest, setIsCompletingPaymentRequest] = useState<boolean>(false);
  const [isLoadingRequestAfterUpdate, setIsLoadingRequestAfterUpdate] = useState<boolean>(false);
  const [isRefundModalOpenedFromPayment, setIsRefundModalOpenedFromPayment] = useState<boolean>(false);
  const [forwardPopOverAnchorElement, setForwardPopoverAnchorElement] = useState<null | HTMLElement>(null);
  const [canSendRequestCommunicationFromMenu, setCanSendRequestCommunicationFromMenu] = useState<boolean>(false);
  const [canCloseRequestFromMenu, setCanCloseRequestFromMenu] = useState<boolean>(false);
  const [canPaySelectedRequests, setCanPaySelectedRequests] = useState<boolean>(false);
  const [canPayError, setCanPayError] = useState<string | undefined>();
  const [displayPayRequestsError, setDisplayPayRequestsError] = useState<boolean>(false);
  const [displayPaymentSuccessful, setDisplayPaymentSuccessful] = useState(false);

  const paymentsGridApi = useGridApiRef();
  const paymentRequestsGridApi = useGridApiRef();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const tabRef = useRef<any>(null);
  const isInitialMount = useRef(true);
  const previousTenantIdRef = useRef(tenantId);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation<{ refresh?: boolean; refreshRequests?: boolean }>();
  const matchesXsDown = useMediaQuery(theme.breakpoints.down('xs'));
  const matchesSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const [pageTitle, setPageTitle] = useState<JSX.Element | undefined>();
  const iconSize = matchesXsDown ? 'medium' : 'small';
  const canCreatePaymentRequest = checkPermission(Permission.PaymentRequestCreate, user?.relationship?.role);
  const canUpdatePaymentRequest = checkPermission(Permission.PaymentRequestUpdate, user?.relationship?.role);
  const canForwardPaymentRequest = user?.relationship?.role === AppRole.Admin || user?.relationship?.role === AppRole.Editor;
  const canCreateRefund = checkPermission(Permission.RefundCreate, user?.relationship?.role);
  const canCancelPayment = checkPermission(Permission.PaymentCancel, user?.relationship?.role);
  const isUserReader = user?.relationship?.role === AppRole.Reader || user?.relationship?.role === AppRole.ApteanAdmin;
  const { previewSettings } = tenantAccount?.settings?.integrationSettings || {};
  const hasPreviewWithNoEmail = previewSettings?.enabled && !previewSettings.email;
  const [reminderDialogOpen, setReminderDialogOpen] = useState(false);
  const isTransitioningMerchant =
    tenantAccount?.company?.verification?.transitionStatus === TransitionStatus.Requested && tenantAccount?.payFacType !== PayFac.Ptt;
  // snackbar settings
  const anchorOrigin: { vertical: 'bottom' | 'top'; horizontal: 'center' | 'left' | 'right' } = {
    vertical: 'bottom',
    horizontal: 'center',
  };

  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  // Infinite load page size.
  const pageSize = 25;

  const loadRequestAfterUpdate = () => {
    if (activeViewPaymentRequestRecord?.id && detailsDialogOpen) {
      setIsLoadingRequestAfterUpdate(true);
      dispatch(fetchPaymentRequestByIdAfterUpdate(paymentRequestOrder, activeViewPaymentRequestRecord.id));
    }
  };

  const clearPaymentRequestMenuFlags = () => {
    setSelectedPaymentRequests(undefined);
    setCanSendRequestCommunicationFromMenu(false);
    setCanCloseRequestFromMenu(false);
  };

  // Account requirements are now sourced from the tenant account query (QueryTenantAccount)
  // which already includes requirements data - no need for a separate fetchAccountRequirements call.

  // Reload payment requests when the sort order changes (user-initiated sort only).
  useEffect(() => {
    // Skip initial mount — the [tabPath] effect handles the first load.
    if (isInitialMount.current) {
      return;
    }
    if (tenantId && paymentRequests) {
      dispatch(
        fetchPaymentRequestList(
          undefined,
          pageSize,
          paymentRequestOrder,
          paymentRequestQueryString,
          undefined,
          allPaymentRequestStatusList,
          paymentRequestFilterCustomerOption?.id,
        ),
      );
      clearPaymentRequestMenuFlags();
    }
  }, [paymentRequestOrder]);

  // Reload payments when the sort order changes (user-initiated sort only).
  useEffect(() => {
    // Skip initial mount — the [tabPath] effect handles the first load.
    if (isInitialMount.current) {
      return;
    }
    if (tenantId && payments) {
      dispatch(
        fetchPaymentList(
          undefined,
          pageSize,
          paymentOrder,
          paymentQueryString,
          allPaymentsStatusList,
          allPaymentsStatusExtendedList,
          paymentFilterFromDate,
          paymentFilterToDate,
          paymentFilterFromAmount,
          paymentFilterToAmount,
          paymentFilterCustomerOption?.id,
          paymentFilterPaymentMethodOption?.id,
          paymentFilterPaymentMethodType,
        ),
      );
    }
  }, [paymentOrder]);

  // Update list in the active tab with the query string changes only.
  useEffect(() => {
    // Skip initial mount — search effects should only fire on user-initiated search changes.
    if (isInitialMount.current) {
      return;
    }
    // Skip when tenantId just changed — the [tenantId] effect handles that reload.
    if (previousTenantIdRef.current !== tenantId) {
      previousTenantIdRef.current = tenantId;
      return;
    }
    if (tenantId) {
      if (tabValue === 0) {
        dispatch(
          fetchPaymentList(
            undefined,
            pageSize,
            paymentOrder,
            paymentQueryString,
            allPaymentsStatusList,
            allPaymentsStatusExtendedList,
            paymentFilterFromDate,
            paymentFilterToDate,
            paymentFilterFromAmount,
            paymentFilterToAmount,
            paymentFilterCustomerOption?.id,
            paymentFilterPaymentMethodOption?.id,
            paymentFilterPaymentMethodType,
          ),
        );
      } else if (tabValue === 1) {
        dispatch(
          fetchPaymentRequestList(
            undefined,
            pageSize,
            paymentRequestOrder,
            paymentRequestQueryString,
            undefined,
            allPaymentRequestStatusList,
            paymentRequestFilterCustomerOption?.id,
          ),
        );
      }
    }
  }, [paymentRequestQueryString, paymentQueryString]);

  // Updates the payment details modal with the newly updated record
  useEffect(() => {
    if (activeViewPaymentRequestRecord) {
      const updatedRecord = payRequestConnection?.nodes.find(item => item?.id === activeViewPaymentRequestRecord.id);
      if (updatedRecord) {
        setActiveViewPaymentRequestRecord(updatedRecord);
      }
    }
  }, [payRequestConnection]);

  useEffect(() => {
    if (activeViewPaymentRecord) {
      const updatedRecord = paymentConnection?.nodes.find(item => item?.id === activeViewPaymentRecord.id);
      if (updatedRecord) {
        setActiveViewPaymentRecord(updatedRecord);
      }
    }
  }, [paymentConnection]);

  useEffect(() => {
    if (reminderStatus !== undefined || remindPaymentRequestsSuccessCount > 0) {
      dispatch(clearReminderStatus());
      if (tenantId) {
        dispatch(
          fetchPaymentRequestList(
            undefined,
            pageSize,
            paymentRequestOrder,
            paymentRequestQueryString,
            undefined,
            allPaymentRequestStatusList,
            paymentRequestFilterCustomerOption?.id,
          ),
        );
        clearPaymentRequestMenuFlags();
        loadRequestAfterUpdate();
      }
      setRemindDisabled(false);
      dispatch(fetchRemindPaymentRequestsSuccessCount(0));
    }
  }, [reminderStatus, remindPaymentRequestsSuccessCount]);

  useEffect(() => {
    if (updatePaymentRequestStatus !== undefined) {
      dispatch(clearUpdatePaymentRequestStatus());
      dispatch(clearUpdatePaymentRequestError());
      if (tenantId) {
        dispatch(
          fetchPaymentRequestList(
            undefined,
            pageSize,
            paymentRequestOrder,
            paymentRequestQueryString,
            undefined,
            allPaymentRequestStatusList,
            paymentRequestFilterCustomerOption?.id,
          ),
        );
        clearPaymentRequestMenuFlags();
        loadRequestAfterUpdate();
      }
      setUpdatePaymentRequestDisabled(false);
    }
  }, [updatePaymentRequestStatus]);

  useEffect(() => {
    setIsCloseOrCompleteWaiting(false);
  }, [closeOrCompleteError]);
  // When the tab path changes, set the visible tab.
  useEffect(() => {
    let contentTitle;
    let ariaLabel;
    switch (tabPath) {
      case RoutePath.Requests:
        if (tabValue !== 1) {
          setTabValue(1);
          dispatch(fetchLastTabPath(RoutePath.Requests));
        }
        // Lazy load payment requests if not already loaded for this tenant
        if (tenantId && !paymentRequests && !isPaymentRequestListInFlight) {
          dispatch(
            fetchPaymentRequestList(
              undefined,
              pageSize,
              paymentRequestOrder,
              paymentRequestQueryString,
              undefined,
              allPaymentRequestStatusList,
              paymentRequestFilterCustomerOption?.id,
            ),
          );
          clearPaymentRequestMenuFlags();
        }
        contentTitle = matchesSmDown ? 'Requests' : 'Payment Requests';
        ariaLabel = 'Payment Requests';
        break;
      case RoutePath.Payments:
      default:
        if (tabValue !== 0) {
          setTabValue(0);
          dispatch(fetchLastTabPath(RoutePath.Payments));
        }
        // Lazy load payments if not already loaded for this tenant
        if (tenantId && !payments && !isPaymentListInFlight) {
          dispatch(
            fetchPaymentList(
              undefined,
              pageSize,
              paymentOrder,
              paymentQueryString,
              allPaymentsStatusList,
              allPaymentsStatusExtendedList,
              paymentFilterFromDate,
              paymentFilterToDate,
              paymentFilterFromAmount,
              paymentFilterToAmount,
              paymentFilterCustomerOption?.id,
              paymentFilterPaymentMethodOption?.id,
              paymentFilterPaymentMethodType,
            ),
          );
        }
        contentTitle = 'Payments';
        ariaLabel = contentTitle;
        break;
    }
    setPageTitle(
      <Typography variant={'title'} className={classes.pageTitle} aria-label={ariaLabel}>
        {contentTitle}
      </Typography>,
    );
  }, [tabPath]);
  useEffect(() => {
    // When the tab path changes, set the correct url path
    switch (tabValue) {
      case 1:
        if (tabPath !== RoutePath.Requests) {
          history.push(RoutePath.Requests);
          dispatch(fetchLastTabPath(RoutePath.Requests));
        }
        break;
      case 0:
      default:
        if (tabPath !== RoutePath.Payments) {
          history.push(RoutePath.Payments);
          dispatch(fetchLastTabPath(RoutePath.Payments));
        }
        break;
    }
    // clearing the selected records in case tab value changes as we do not retain selected data
    if (selectedPayment) setSelectedPayment(undefined);
    if (selectedPaymentRequests) clearPaymentRequestMenuFlags();
  }, [tabValue]);
  useEffect(() => {
    if (paymentRequestByIdAfterUpdate) {
      setActiveViewPaymentRequestRecord(paymentRequestByIdAfterUpdate);
      setIsLoadingRequestAfterUpdate(false);
      dispatch(capturePaymentRequestByIdAfterUpdate(undefined));
    }

    if (paymentRequestByIdAfterUpdateError) {
      setIsLoadingRequestAfterUpdate(false);
    }
  }, [paymentRequestByIdAfterUpdate, paymentRequestByIdAfterUpdateError]);

  useEffect(() => {
    if (dialogOpen && verificationStatus && verificationStatus !== 'ERROR') {
      setDialogOpen(false);
      dispatch(clearVerificationStatus());
    }
  }, [verificationStatus]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      tabRef?.current?.updateIndicator();
    }, theme.transitions.duration.enteringScreen);
    return () => {
      clearTimeout(timeout);
    };
  }, [theme]);

  useEffect(() => {
    if (isPaymentReceiptResent) {
      setTimeout(() => {
        dispatch(fetchIsPaymentReceiptResent(false));
      }, 5000);
    }
  }, [isPaymentReceiptResent]);

  useEffect(() => {
    if (resendPaymentReceiptError) {
      setTimeout(() => {
        dispatch(fetchResendPaymentReceiptError(undefined));
      }, 5000);
    }
  }, [resendPaymentReceiptError]);

  const handlePaymentRequestsReload = () => {
    if (tenantId) {
      dispatch(
        fetchPaymentRequestList(
          undefined,
          pageSize,
          paymentRequestOrder,
          paymentRequestQueryString,
          undefined,
          allPaymentRequestStatusList,
          paymentRequestFilterCustomerOption?.id,
        ),
      );
      clearPaymentRequestMenuFlags();
    }
  };
  const handlePaymentsReload = () => {
    if (tenantId) {
      dispatch(
        fetchPaymentList(
          undefined,
          pageSize,
          paymentOrder,
          paymentQueryString,
          allPaymentsStatusList,
          allPaymentsStatusExtendedList,
          paymentFilterFromDate,
          paymentFilterToDate,
          paymentFilterFromAmount,
          paymentFilterToAmount,
          paymentFilterCustomerOption?.id,
          paymentFilterPaymentMethodOption?.id,
          paymentFilterPaymentMethodType,
        ),
      );
      setSelectedPayment(undefined);
    }
  };
  useEffect(() => {
    // Skip initial mount — the [tabPath] effect handles the first load.
    // This effect only handles tenant switches while the component is already mounted.
    if (isInitialMount.current) {
      return;
    }
    // Keep the ref in sync so the query-string effect can detect tenant changes.
    previousTenantIdRef.current = tenantId;
    // Reload data for the active tab only when the tenant id changes.
    if (tabValue === 0) {
      handlePaymentsReload();
    } else if (tabValue === 1) {
      handlePaymentRequestsReload();
    }
  }, [tenantId]);

  useEffect(() => {
    if (reloadPaymentsAfterFilter) {
      dispatch(fetchReloadPaymentsAfterFilter(false));
      // reloading payments due to filter update
      handlePaymentsReload();
    }
  }, [reloadPaymentsAfterFilter]);

  useEffect(() => {
    if (reloadPaymentRequestsAfterFilter) {
      dispatch(fetchReloadPaymentRequestsAfterFilter(false));
      // reloading payments due to filter update
      handlePaymentRequestsReload();
    }
  }, [reloadPaymentRequestsAfterFilter]);

  useEffect(() => {
    if (forwardPaymentRequestSuccess && !forwardPaymentRequestSuccess?.error) {
      setForwardPopoverAnchorElement(null);
      setTimeout(() => {
        setDisplayForwardPaymentRequestSuccessful(true);
        setTimeout(() => {
          setDisplayForwardPaymentRequestSuccessful(false);
          setForwardPaymentRequestSuccessMessage('');
          dispatch(captureForwardPaymentRequestSucccess(null));
        }, 5000);
      }, 1500);

      handlePaymentRequestsReload();
    }
  }, [forwardPaymentRequestSuccess]);

  const clearCreatePaymentSuccessMessage = () => {
    setDisplayPaymentSuccessful(false);
    dispatch(fetchCreatePaymentSuccessMessage(undefined));
  };

  useEffect(() => {
    if (createPaymentSuccessMessage) {
      setDisplayPaymentSuccessful(true);
      handlePaymentsReload();
      setTimeout(() => {
        clearCreatePaymentSuccessMessage();
      }, 10000);
    }
  }, [createPaymentSuccessMessage]);

  useEffect(() => {
    if (paymentRequestSuccessMessage) {
      handlePaymentRequestsReload();
    }
  }, [paymentRequestSuccessMessage]);

  useEffect(() => {
    if (isTransitioningMerchant) {
      setReminderDialogOpen(true);
    }
  }, [tenantAccount]);

  // If navigated here after a payment/request creation, force a reload once tenantId is ready.
  useEffect(() => {
    if (!tenantId) return;
    if (location.state?.refresh) {
      handlePaymentsReload();
      history.replace(location.pathname, {});
    }
    if (location.state?.refreshRequests) {
      handlePaymentRequestsReload();
      history.replace(location.pathname, {});
    }
  }, [tenantId, location.pathname]);

  // The export dialog hands a finished report to the browser and shows its own errors. A download
  // started from the toolbar has neither, so its outcome is picked up here. This has to stay above
  // the loading early return further down, or the hook would come and go with it.
  useEffect(() => {
    if (!directExportInFlight) {
      return;
    }

    if (paymentsReport) {
      setDirectExportInFlight(false);
      if (paymentsReport.downloadUrl) {
        // A capped export completes with a partial file. Handing that over without saying so is the
        // silent-short-file problem the report's own truncated flag exists to prevent.
        if (paymentsReport.truncated) {
          setDirectExportError({ message: truncatedExportMessage(paymentsReport.rowLimit) } as Error);
        }
        // The link is built here rather than rendered, because this view swaps itself for a loading
        // screen whenever the list reloads and a report landing then would find nothing to click.
        const link = document.createElement('a');
        link.href = paymentsReport.downloadUrl;
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        // No url means no file to hand over, and with no dialog on screen nothing else would say so.
        setDirectExportError({ message: 'Unable to download the Payments Report.' } as Error);
      }
      dispatch(capturePaymentsReport(undefined));
    } else if (paymentsReportError) {
      setDirectExportError(paymentsReportError);
      setDirectExportInFlight(false);
      dispatch(capturePaymentsReportError(undefined));
    }
  }, [directExportInFlight, paymentsReport, paymentsReportError]);

  // Mark initial mount as complete AFTER all other effects have run.
  // This must be the last useEffect so that all effects above see isInitialMount.current === true
  // on the first render and skip their mount-time execution.
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    }
  }, []);

  const handleSettingsClick = () => {
    history.push('/settings');
  };
  const sendRefund = (paymentId: string, refundReason: string, amount: number | null, paymentRequestId?: string) => {
    if (tenantId) {
      if (!refundIdempotencyKey) {
        //If an idempotency key does not exist in state, we know this is a new refund
        const uid = uuid4();
        dispatch(fetchRefundIdempotencyKey(uid));
        dispatch(refund(uid, paymentId, refundReason, amount, paymentRequestId));
      } else {
        //This is a repeated refund/double click (not sure this can actually happen but its here just in case)
        dispatch(refund(refundIdempotencyKey, paymentId, refundReason, amount, paymentRequestId));
      }
    }
  };
  const clearRefundStateStatus = () => {
    dispatch(clearRefundStatus());
  };
  const isActiveTabLoading = tabValue === 0 ? !paymentConnection : !payRequestConnection;
  if (networkBusy || isActiveTabLoading) {
    return (
      <Grid container justifyContent={'center'}>
        <Grid item className={classes.loadingGridItem}>
          <Paper className={classes.paper}>Loading!</Paper>
        </Grid>
      </Grid>
    );
  }

  // Payment Request functions
  const updatePaymentRequestQueryString = (queryString: string | undefined) => {
    dispatch(capturePaymentRequestSearch(queryString));
  };

  const clearPaymentRequestSearchError = () => {
    if (searchError) dispatch(captureSearchError(undefined));
  };

  const loadPaymentRequestsPage = (endEdge: string) => {
    if (tenantId && !isPaymentRequestListInFlight) {
      dispatch(
        fetchPaymentRequestList(
          endEdge,
          pageSize,
          paymentRequestOrder,
          paymentRequestQueryString,
          undefined,
          allPaymentRequestStatusList,
          paymentRequestFilterCustomerOption?.id,
        ),
      );
    }
  };
  const handlePaymentRequestSort = (direction: OrderDirection, fieldName: string) => {
    const field = fieldName as PaymentRequestOrderField;
    setPaymentRequestDirection(direction);
    setPaymentRequestField(field);
    setPaymentRequestOrder({ direction, field });
  };

  const handlePaymentSort = (direction: OrderDirection, fieldName: string) => {
    const field = fieldName as PaymentOrderField;
    setPaymentDirection(direction);
    setPaymentField(field);
    setPaymentOrder({ direction, field });
  };
  const loadPaymentsPage = (endEdge: string) => {
    if (tenantId && !isPaymentListInFlight) {
      dispatch(
        fetchPaymentList(
          endEdge,
          pageSize,
          paymentOrder,
          paymentQueryString,
          allPaymentsStatusList,
          allPaymentsStatusExtendedList,
          paymentFilterFromDate,
          paymentFilterToDate,
          paymentFilterFromAmount,
          paymentFilterToAmount,
          paymentFilterCustomerOption?.id,
          paymentFilterPaymentMethodOption?.id,
          paymentFilterPaymentMethodType,
        ),
      );
    }
  };

  const updatePaymentQueryString = (queryString: string | undefined) => {
    dispatch(capturePaymentSearch(queryString));
  };

  const clearPaymentSearchError = () => {
    if (searchError) dispatch(captureSearchError(undefined));
  };

  const handleActiveTabReload = () => {
    dispatch(captureSearchError(undefined));
    if (tabValue === 0) {
      if (paymentsGridApi?.current) {
        // Clear selection state.
        paymentsGridApi?.current.setSelectionModel([]);
      }
      handlePaymentsReload();
    } else if (tabValue === 1) {
      if (paymentRequestsGridApi?.current) {
        // Clear selection state.
        paymentRequestsGridApi?.current.setSelectionModel([]);
      }
      handlePaymentRequestsReload();
    }
  };
  const handlePaymentRequestView = (record: PaymentRequest | undefined) => {
    if (record) {
      setActiveViewPaymentRequestRecord(record);
      setDetailsDialogOpen(true);
    }
  };
  const handleDetailsClose = () => {
    setDetailsDialogOpen(false);
    dispatch(clearReminderStatus());
    setRemindDisabled(false);
    dispatch(clearUpdatePaymentRequestStatus());
    dispatch(clearUpdatePaymentRequestError());
    dispatch(captureCloseOrCompleteError(undefined));
    dispatch(capturePaymentRequestByIdAfterUpdateError(undefined));
    setUpdatePaymentRequestDisabled(false);
    setIsCompletingPaymentRequest(false);
    setIsClosingPaymentRequest(false);
  };
  const handlePaymentDetailsClose = () => {
    setPaymentDetailsDialogOpen(false);
  };

  const handlePaymentView = (record: Payment | undefined) => {
    if (record) {
      setActiveViewPaymentRecord(record);
      setPaymentDetailsDialogOpen(true);
    }
  };

  const handlePaymentRemind = (record: PaymentRequest | undefined) => {
    if (record) {
      const { referenceNumber, amount, id, invoiceIds, invoiceId } = record;
      const updatedInvoiceId: string | undefined = invoiceId === null ? undefined : invoiceId;
      const updatedInvoiceIds: string[] | undefined = invoiceIds === null ? undefined : invoiceIds;
      const email = record.communications.find(item => item?.communicationType === CommunicationType.Email)?.email;
      const phone = record.communications.find(item => item?.communicationType === CommunicationType.Sms)?.phoneNumber;
      const customerId = record?.owner?.customerId;
      if (referenceNumber && amount && (email || phone || customerId) && id) {
        dispatch(
          remindPaymentRequest(referenceNumber, amount, id, updatedInvoiceId, updatedInvoiceIds, email as string, phone as string),
        );
        setRemindDisabled(true);
      }
    }
  };
  const handlePaymentRequestsRemindFromMenu = (records: PaymentRequest[] | undefined) => {
    if (records) {
      dispatch(remindPaymentRequests(records));
    }
  };
  const handleUpdatePaymentRequest = (record: PaymentRequest | undefined, amount: string) => {
    dispatch(clearUpdatePaymentRequestError());
    const updatedAmount = Math.round(parseFloat(amount) * 100);
    if (record && record.amount && updatedAmount > 0 && updatedAmount < record.amount) {
      const { referenceNumber, id, invoiceId, invoiceIds } = record;
      const updatedInvoiceId: string | undefined = invoiceId === null ? undefined : invoiceId;
      const updatedInvoiceIds: string[] | undefined = invoiceIds === null ? undefined : invoiceIds;
      const email = record.communications.find(item => item?.communicationType === CommunicationType.Email)?.email;
      const phone = record.communications.find(item => item?.communicationType === CommunicationType.Sms)?.phoneNumber;
      const customerId = record?.owner?.customerId;
      if (referenceNumber && (email || phone || customerId) && id) {
        dispatch(
          updatePaymentRequest(
            referenceNumber,
            updatedAmount,
            id,
            updatedInvoiceId,
            updatedInvoiceIds,
            email as string,
            phone as string,
          ),
        );
        setUpdatePaymentRequestDisabled(true);
      }
    }
  };
  const updatePaymentRequestCancel = () => {
    dispatch(clearUpdatePaymentRequestError());
  };

  const clearRefundError = () => {
    if (refundError) dispatch(captureRefundError(undefined));
  };
  const handleRefundSubmit = () => {
    setRefundDialogOpen(false);
    handlePaymentRequestsReload();
    handlePaymentsReload();
    clearRefundError();
  };
  const handleRefundClose = () => {
    setRefundDialogOpen(false);
    clearRefundError();
    setActiveRefundPaymentRequestRecord(undefined);
    setActiveIssueRefundPaymentRecord(undefined);
  };
  const handlePaymentRefund = (record: Payment | undefined, openedFromPayment: boolean) => {
    if (record) {
      setPaymentDetailsDialogOpen(false);
      setActiveRefundPaymentRecord(record);
      setPaymentRefundDialogOpen(true);
      setIsRefundModalOpenedFromPayment(openedFromPayment);
    }
  };
  const handlePaymentRefundSubmit = () => {
    setPaymentRefundDialogOpen(false);
    // A refunded payment can be attached to a payment request, whose status the refund moves too.
    // Switching tabs does not refetch, so without this the requests grid keeps serving its
    // pre-refund snapshot until a manual reload. handleRefundSubmit reloads both for this reason.
    handlePaymentRequestsReload();
    handlePaymentsReload();
    clearRefundError();
  };
  const handlePaymentRefundClose = () => {
    setPaymentRefundDialogOpen(false);
    clearRefundError();
  };

  const handlePaymentRequestClose = (record: PaymentRequest | undefined) => {
    if (record) {
      handlePaymentRequestView(record);
      setIsClosingPaymentRequest(true);
    }
  };

  const closeOrCompleteUpsertPaymentRequest = (
    referenceId: string,
    amount: number,
    id: string,
    status: PaymentRequestStatus,
    statusReason: string,
    callback: () => void,
  ) => {
    dispatch(closeOrCompletePaymentRequest(referenceId, amount, id, status, statusReason, callback));
  };

  const closeOrCompleteCallback = () => {
    if (isClosingPaymentRequest) setIsClosingPaymentRequest(false);
    if (isCompletingPaymentRequest) setIsCompletingPaymentRequest(false);
    setIsCloseOrCompleteWaiting(false);
    handlePaymentRequestsReload();
    loadRequestAfterUpdate();
  };

  const openForwardDialog = (e: SyntheticEvent<HTMLElement>) => setForwardPopoverAnchorElement(e.currentTarget);
  const closeForwardDialog = () => setForwardPopoverAnchorElement(null);

  const handleCloseOrCompleteSubmit = (record: PaymentRequest | undefined, status: PaymentRequestStatus, statusReason: string) => {
    setIsCloseOrCompleteWaiting(true);
    if (record && record.referenceNumber && record.amount && record.id) {
      closeOrCompleteUpsertPaymentRequest(
        record.referenceNumber,
        record.amount,
        record.id,
        status,
        statusReason,
        closeOrCompleteCallback,
      );
    }
  };

  const clearCloseOrCompleteError = () => {
    dispatch(captureCloseOrCompleteError(undefined));
  };

  const handleSelectedPaymentRequestsChange = (records?: PaymentRequest[]) => {
    setSelectedPaymentRequests(records);
    if (records && records.length > 0) {
      if (!paymentRequestFeatures?.consolidatedPayment && records.length > 1) {
        setCanPaySelectedRequests(false);
        setCanPayError('Unable to consolidate payments. This feature is not enabled for the merchant.');
      } else if (records.length > 10) {
        setCanPaySelectedRequests(false);
        setCanPayError('Only 10 requests may be selected for payment at the same time.');
      } else if (!isUserReader) {
        // Check if all can are unpaid/not fully paid.
        let allUnpaid = true;
        let allSameCustomer = true;
        let allSamePayer = true;
        let previousCustomerId: string;
        let previousPayerEmail: string;
        records.forEach((request: PaymentRequest) => {
          // Check if any logic is already failing, don't do compares.
          if (allUnpaid && allSameCustomer && allSamePayer) {
            if (
              request.status !== PaymentRequestStatus.Unpaid &&
              request.status !== PaymentRequestStatus.PartiallyPaid &&
              request.status !== PaymentRequestStatus.Failed
            ) {
              // Is partially paid allowed?
              allUnpaid = false;
            }
            if (allUnpaid && request.customer && request.customer.id) {
              // Only do compare if customer exists on the request. Non customer requests can be paired with same email requests.
              if (previousCustomerId && previousCustomerId !== request.customer.id) {
                allSameCustomer = false;
              }
              previousCustomerId = request.customer.id;
            }
            if (allSameCustomer && allUnpaid && request.communications && request.communications[0]) {
              const initialComm = request.communications[0];
              const sentTo = initialComm.email;
              if (previousPayerEmail && sentTo && previousPayerEmail !== sentTo) {
                allSamePayer = false;
              } else if (sentTo) {
                previousPayerEmail = sentTo;
              }
            }
          }
        });
        // Check if all of same customer.
        setCanPaySelectedRequests(allUnpaid && allSameCustomer && allSamePayer);
        if (allUnpaid && allSameCustomer && allSamePayer) {
          setDisplayPayRequestsError(false);
          setCanPayError(undefined);
        } else if (!allUnpaid) {
          setCanPayError('To pay requests, all selected requests must be either in an unpaid, partially paid, or failed state.');
        } else if (!allSamePayer) {
          setCanPayError('To pay requests, all selected requests must be for the same payer.');
        } else {
          setCanPayError('To pay requests, all selected requests must be for the same customer.');
        }
      } else {
        // Having only userReader permissions will disable the payment button.
        setCanPaySelectedRequests(false);
        setCanPayError(undefined);
      }
      // checking whether we can close the request from menu option or not
      const firstRequest = records[0];
      const closeRequest =
        records.length === 1 &&
        (firstRequest?.status === PaymentRequestStatus.Unpaid ||
          firstRequest?.status === PaymentRequestStatus.Failed ||
          firstRequest?.status === PaymentRequestStatus.Canceled);
      setCanCloseRequestFromMenu(closeRequest);

      // checking whether we can send the communication of requests from menu option or not
      const hasAllowedStatus = !records.find(
        request =>
          !(
            request?.status === PaymentRequestStatus.Unpaid ||
            request?.status === PaymentRequestStatus.Failed ||
            request?.status === PaymentRequestStatus.Canceled ||
            request?.status === PaymentRequestStatus.PartiallyPaid
          ),
      );
      const hasRequestsWithCommunication = !records.find(
        request => !request?.communications || (!!request.communications && request.communications.length < 1),
      );
      setCanSendRequestCommunicationFromMenu(hasAllowedStatus && hasRequestsWithCommunication);
    } else {
      setCanPayError(undefined);
      clearPaymentRequestMenuFlags();
    }
  };

  const handlePaymentDetailsFromRefund = (paymentRecord: Payment) => {
    handlePaymentRefundClose();
    handlePaymentView(paymentRecord);
  };
  const handlePaymentRequestDetailsFromPayment = (paymentRequestRecord: PaymentRequest | undefined) => {
    handlePaymentDetailsClose();
    setActiveViewPaymentRequestRecord(paymentRequestRecord);
    setDetailsDialogOpen(true);
  };
  const handlePaymentRequestRefundFromModal = (
    paymentRequestRecord: PaymentRequest | undefined,
    paymentRecord: Payment | undefined,
  ) => {
    if (paymentRequestRecord && paymentRecord) {
      setDetailsDialogOpen(false);
      setActiveRefundPaymentRequestRecord(paymentRequestRecord);
      setActiveIssueRefundPaymentRecord(paymentRecord);
      setRefundDialogOpen(true);
    }
  };
  const handleRequestModalViewFromRefund = (record: PaymentRequest | undefined) => {
    if (record) {
      handleRefundClose();
      setActiveViewPaymentRequestRecord(record);
      setDetailsDialogOpen(true);
    }
  };

  const calculateRefundedAmount = (payment: Payment | undefined): number => {
    if (!payment) return 0;
    let refunded = 0;
    payment.refunds.forEach(refund => {
      if (refund?.status === RefundStatus.Completed || refund?.status === RefundStatus.Pending) {
        refunded += refund.amount || 0;
      }
    });
    return refunded;
  };

  const isPartialRefund = (payment: Payment | undefined): boolean => {
    if (!payment) return false;
    const refunded = calculateRefundedAmount(payment);
    const totalAmount = payment.amountBeforeFees ?? payment.amount ?? 0;
    return refunded > 0 && refunded < totalAmount;
  };

  // There is ONE action button and this decides which one it is. Void is offered only while the payment
  // can still be reversed at the processor at no cost: the tenant must be opted in, it must be a completed
  // card sale still awaiting settlement, and it must carry no refund at all.
  //
  // A consolidated payment (more than one allocation) IS voidable: the void reverses the whole sale and
  // the service reopens every payment request it covered and restores any applied credit. What rules a
  // void out is a refund - completed OR still pending. The void reverses the full sale and leaves the
  // separate refund transaction alone, so voiding a payment with any refund on it would pay the
  // cardholder back twice. amountRefunded is the service's figure; calculateRefundedAmount also counts
  // refunds still pending, which amountRefunded may not yet reflect. The service refuses this too.
  //
  // settlementStatus on its own is NOT sufficient. It is written from autoCapture plus payment status with
  // no payment-method check, so an auto-capture ACH payment also reads PENDING - and the service refuses a
  // void on anything that is not a credit card. Keying the button on settlement alone would show Void on
  // ACH payments and always fail.
  //
  // A payment paid entirely with credit (amount 0, creditAmount > 0) charged nothing and never reached the
  // processor, so neither the card-only nor the settlement rule applies - it carries no settlementStatus,
  // and its payment method (card OR bank) is only what the payer had selected. Voiding it gives the credit
  // back and reopens its requests. It never settles, so the service allows it for 24 hours after completion
  // instead (CREDIT_ONLY_VOID_WINDOW_HOURS in PaymentsService) - mirrored here so the button closes with it.
  //
  // Takes the payment rather than reading selectedPayment, because two places need this answer about
  // two different records: the toolbar asks about the selected row, the details dialog about the one
  // it is showing. Duplicating the rule for the second caller is how the two disagree.
  //
  // Unlike isPaymentRefundable this is pure: it is evaluated during render, so it must not dispatch.
  const isPaymentVoidable = (payment: Payment | undefined) => {
    if (!payment) return false;
    if (!tenantAccount?.settings?.features?.payments?.allowVoid) return false;
    if ((payment.amountRefunded ?? 0) > 0 || calculateRefundedAmount(payment) > 0) return false;
    if (payment.amount === 0 && (payment.creditAmount ?? 0) > 0) {
      const completedAt = payment.completedTimestamp ? new Date(payment.completedTimestamp).getTime() : NaN;
      return payment.status === PaymentStatus.Completed && Date.now() - completedAt < creditOnlyVoidWindowMs;
    }
    if (payment.paymentMethod?.type !== PaymentMethodType.CreditCard) return false;
    return payment.status === PaymentStatus.Completed && payment.settlementStatus === SettlementStatus.Pending;
  };

  const clearVoidState = () => {
    dispatch(clearVoidStatus());
    dispatch(captureVoidError(undefined));
    dispatch(captureVoidErrorReasonCode(undefined));
  };

  const sendVoid = (paymentId: string, reason: string) => {
    dispatch(voidPayment(paymentId, reason));
  };

  const handlePaymentVoid = (record: Payment | undefined) => {
    if (record) {
      // Close the details dialog first, exactly as handlePaymentRefund does. This is reached from
      // there as well as from the toolbar, and without it the void dialog stacks on top of an open
      // details dialog. Harmless no-op when it was not open.
      setPaymentDetailsDialogOpen(false);
      clearVoidState();
      setActiveVoidPaymentRecord(record);
      setVoidDialogOpen(true);
    }
  };

  const handleVoidSubmit = () => {
    setVoidDialogOpen(false);
    // A void reopens every payment request the payment covered - all of them for a consolidated
    // payment - back to UNPAID (or PARTIALLY_PAID when partial payments are enabled), so the requests
    // grid is stale the moment the void lands.
    handlePaymentRequestsReload();
    handlePaymentsReload();
    clearVoidState();
  };

  const handleVoidClose = () => {
    setVoidDialogOpen(false);
  };

  // The single expression that decides whether a reversal is a void or a refund, for BOTH surfaces:
  // the toolbar below and the details dialog. The permission belongs in here rather than only in a
  // button's disabled state - without it a user holding RefundCreate but not PaymentCancel read
  // 'Void' on a toolbar button they could never press, while the dialog, which has always folded
  // canCancelPayment into its own label, offered them Refund. Same payment, two different answers.
  const isVoidAction = (payment: Payment | undefined) => canCancelPayment && isPaymentVoidable(payment);

  // Evaluated once per render rather than per JSX attribute, and it drives every part of the one button.
  const voidSelected = isVoidAction(selectedPayment);
  const reversalActionLabel = voidSelected ? 'Void' : 'Refund';

  const isPaymentRefundable = () => {
    const payment = selectedPayment;
    if (!payment) return false;

    if (payment.paymentRequestAllocation && payment.paymentRequestAllocation.length > 1) return false;

    const refunded = calculateRefundedAmount(payment);

    if (refunded > 0) {
      dispatch(fetchIsPaymentRefunded(true));
      dispatch(fetchPaymentRefundedAmount(refunded));
    } else {
      dispatch(fetchIsPaymentRefunded(false));
      dispatch(fetchPaymentRefundedAmount(undefined));
    }
    return payment.status === PaymentStatus.Completed && !!payment.amount && refunded < payment.amount;
  };

  const invoiceDetailClicked = (paymentRequestId: string) => {
    setIsInvoiceDetailClicked(true);
    dispatch(fetchPaymentRequestById(paymentRequestOrder, paymentRequestId));
  };

  const invoiceRefundClicked = (paymentRequestId: string) => {
    setIsInvoiceRefundClicked(true);
    dispatch(fetchPaymentRequestById(paymentRequestOrder, paymentRequestId));
  };

  const openModalFromPaymentRequestInvoice = (paymentRecord: Payment | undefined) => {
    if (paymentRequestById || paymentRequestByIdError) {
      if (paymentRequestById) {
        const paymentRequestByIdRecord = paymentRequestById;

        if (isInvoiceDetailClicked) {
          handlePaymentDetailsClose();
          handlePaymentRequestDetailsFromPayment(paymentRequestByIdRecord);
        }
        if (isInvoiceRefundClicked) {
          handlePaymentDetailsClose();
          handlePaymentRequestRefundFromModal(paymentRequestByIdRecord, paymentRecord);
        }
        dispatch(capturePaymentRequestById(undefined));
      }
      if (paymentRequestByIdError) {
        dispatch(capturePaymentRequestByIdError(undefined));
      }
      if (isInvoiceDetailClicked) setIsInvoiceDetailClicked(false);
      if (isInvoiceRefundClicked) setIsInvoiceRefundClicked(false);
    }
  };

  const historyDetailClicked = (paymentId: string) => {
    setIsHistoryDetailClicked(true);
    dispatch(fetchPaymentById(paymentOrder, paymentId));
  };

  const openModalFromPaymentHistory = () => {
    if (paymentById || paymentByIdError) {
      if (paymentById) {
        const paymentByIdRecord = paymentById;

        if (isHistoryDetailClicked) {
          handleDetailsClose();
          handlePaymentView(paymentByIdRecord);
        }
        dispatch(capturePaymentById(undefined));
      }
      if (paymentByIdError) {
        dispatch(capturePaymentByIdError(undefined));
      }
      if (isHistoryDetailClicked) setIsHistoryDetailClicked(false);
    }
  };

  const openPaymentModalFromRefund = (paymentRecord?: Payment) => {
    if (paymentRecord) {
      handleRefundClose();
      handlePaymentView(paymentRecord);
    }
  };

  const refundRequestClicked = (paymentRequestId: string) => {
    setIsRefundRequestClicked(true);
    dispatch(fetchPaymentRequestById(paymentRequestOrder, paymentRequestId));
  };

  const openRequestModalFromRefund = () => {
    if (paymentRequestById || paymentRequestByIdError) {
      if (paymentRequestById) {
        const paymentRequestByIdRecord = paymentRequestById;
        handlePaymentRefundClose();
        handlePaymentRequestView(paymentRequestByIdRecord);
        dispatch(capturePaymentRequestById(undefined));
      }
      if (paymentRequestByIdError) {
        dispatch(capturePaymentRequestByIdError(undefined));
      }
      setIsRefundRequestClicked(false);
    }
  };

  const clearPaymentsReportOrError = () => {
    if (paymentsReport) {
      dispatch(capturePaymentsReport(undefined));
    }

    if (paymentsReportError) {
      dispatch(capturePaymentsReportError(undefined));
    }
  };

  // Mirrors the arguments the payments list is filtered by, so the export dialog only offers to
  // reuse filters when the table actually has some.
  const hasActivePaymentFilters = Boolean(
    paymentQueryString ||
      allPaymentsStatusList?.length ||
      allPaymentsStatusExtendedList?.length ||
      paymentFilterFromDate ||
      paymentFilterToDate ||
      paymentFilterFromAmount !== undefined ||
      paymentFilterCustomerOption?.id ||
      paymentFilterPaymentMethodOption?.id ||
      paymentFilterPaymentMethodType,
  );

  const handleExportToggle = () => {
    setExportDialogOpen(!exportDialogOpen);
    clearPaymentsReportOrError();
  };

  // The report mutation requires both dates and refuses a span over 31 days, so the table's own date
  // filter can only stand in for the dialog's pickers when it supplies a span the export accepts.
  // Anything else - no date filter at all, a custom range wider than 31 days, or one running past
  // today - has no range to carry over, and the dialog stays the only way to ask for one.
  const getExportRangeFromPaymentFilters = (): { end: string; start: string } | undefined => {
    if (!paymentFilterFromDate || !paymentFilterToDate) {
      return undefined;
    }
    // The filters are held as UTC ISO strings, which is what the mutation takes, so read them back
    // in UTC and hand them over as they are.
    const from = DateTime.fromISO(paymentFilterFromDate, { zone: 'utc' });
    const to = DateTime.fromISO(paymentFilterToDate, { zone: 'utc' });
    // Today's upper bound is read off the local date, the way both the filter presets and the
    // dialog's own validation build it, so a merchant ahead of UTC is not sent to the dialog for a
    // range the export would have taken.
    const localNow = new Date();
    const upperLimit = DateTime.utc(localNow.getFullYear(), localNow.getMonth() + 1, localNow.getDate(), 23, 59, 59);
    const isUsable = from.isValid && to.isValid && to >= from && to <= from.plus({ days: 31 }) && to <= upperLimit;

    return isUsable ? { end: to.toString(), start: from.toString() } : undefined;
  };

  // Mirrors how fetchPaymentList narrows the list, so the CSV and the table agree on what a filter
  // means. Amounts are already held in minor units in state, so they pass through untouched, and an
  // absent upper bound means "lower bound and above" exactly as it does for the grid.
  const buildPaymentsExportFilter = (datesFromTableFilter: boolean): PaymentsExportFilter => ({
    amountRange: paymentFilterFromAmount !== undefined ? { start: paymentFilterFromAmount, end: paymentFilterToAmount } : undefined,
    customerId: paymentFilterCustomerOption?.id,
    // Only sent when the export's dates ARE the table's Last Updated filter - taken from it
    // directly, or prefilled into the dialog from it and left alone. Any other range is a report
    // period, which has always meant created date, and reading it as last updated would quietly
    // change which rows the CSV holds. The filter merely being set is not enough to decide this: a
    // range wider than 31 days never reaches the dialog, so its dates are the merchant's own.
    dateRangeType: datesFromTableFilter ? DateRangeType.CompletedOrCreatedTimestamp : undefined,
    extendedPaymentStatus: allPaymentsStatusExtendedList?.length ? allPaymentsStatusExtendedList : undefined,
    paymentMethodId: paymentFilterPaymentMethodOption?.id,
    paymentMethodType: paymentFilterPaymentMethodType,
    queryString: paymentQueryString?.trim() || undefined,
    status: allPaymentsStatusList?.length ? allPaymentsStatusList : undefined,
  });

  const handlePaymentsReport = (
    endDate: string | undefined,
    format: FileFormat,
    startDate: string | undefined,
    applyCurrentFilters: boolean,
    datesFromTableFilter: boolean,
  ) => {
    clearPaymentsReportOrError();
    // A period narrows the filters; it no longer stands in for them. Both dates are absent together
    // on an export of exactly what the table shows.
    const filter = applyCurrentFilters ? buildPaymentsExportFilter(datesFromTableFilter) : undefined;
    dispatch(createPaymentsReport(endDate, filter, format, startDate));
  };

  // Only a table date filter the export can carry skips the dialog: it supplies the period outright,
  // so there is genuinely nothing left to ask. Every other filtered table opens the dialog, where
  // the period is now optional - the merchant sees which filters are being applied, can narrow by
  // date if they want to, and can click Download without touching the pickers. Downloading straight
  // from the toolbar instead would take that choice away rather than making it optional.
  const handleExportClick = () => {
    const filterRange = hasActivePaymentFilters ? getExportRangeFromPaymentFilters() : undefined;
    if (!filterRange) {
      handleExportToggle();
      return;
    }

    setDirectExportError(undefined);
    setDirectExportInFlight(true);
    // The range is the table's date filter itself, so it carries that filter's meaning.
    handlePaymentsReport(filterRange.end, FileFormat.Csv, filterRange.start, true, true);
  };

  const updateExportsCancelledInFlight = (exportsCancelledInFlight: boolean) => {
    dispatch(captureExportsCancelledInFlight(exportsCancelledInFlight));
  };

  const handleAdditionalBannerChange = (hasBanner: boolean) => {
    dispatch(fetchHasAdditionalBanner(hasBanner));
  };

  const handleAddPaymentRequestOpen = () => {
    // Open payment request screen.
    history.push(RoutePath.PaymentRequest);
  };

  const handlePendingBannerClose = () => {
    dispatch(fetchPendingBannerVisible(false));
  };

  const handleResendPaymentReceipt = (paymentId: string | undefined) => {
    if (paymentId) {
      dispatch(resendPaymentReceipt(paymentId));
    }
  };

  const getSelectedPaymentEmail = () => {
    if (selectedPayment?.paymentMethod?.creditCard) {
      return selectedPayment.paymentMethod.creditCard.cardHolder?.email;
    }
    if (selectedPayment?.paymentMethod?.paymentBank) {
      return selectedPayment.paymentMethod.paymentBank.accountHolder?.email;
    }
    return undefined;
  };
  const handlePaymentTerminalOpenFromRequest = () => {
    // Set the state for selected payments and move to the payment screen.
    if (canPaySelectedRequests) {
      dispatch(fetchRequestsToPay(selectedPaymentRequests));
      history.push('/payment');
    } else if (canPayError) {
      setDisplayPayRequestsError(true);
    }
  };
  const handleForwardPaymentRequest = (email: string) => {
    if (selectedPaymentRequests) {
      const input: PaymentRequestForwardInput = { email, paymentRequestId: selectedPaymentRequests[0].id };
      dispatch(forwardPaymentRequest(input));
      setForwardPaymentRequestSuccessMessage(`The payment request has been successfully forwarded to ${email}`);
    }
  };

  const handlePaymentRequestFilterStatusUpdate = (
    statusCount: number,
    paymentRequestStatusFilterList?: AllPaymentRequestsStatusFilterValue[],
  ) => {
    if (statusCount === 0 || statusCount === PR_MAX_STATUS_COUNT) {
      dispatch(fetchPaymentRequestFilterStatusCount(PR_MAX_STATUS_COUNT));
      dispatch(fetchPaymentRequestFilterStatusList(undefined));
      dispatch(fetchAllPaymentRequestStatusList(undefined));

      dispatch(fetchReloadPaymentRequestsAfterFilter(true));
    } else {
      dispatch(fetchPaymentRequestFilterStatusCount(statusCount));
      dispatch(fetchPaymentRequestFilterStatusList(paymentRequestStatusFilterList));

      const updatedStatusList: PaymentRequestStatus[] = [];

      paymentRequestStatusFilterList?.forEach(item => {
        if (item.isSelected) {
          updatedStatusList?.push(item.value as PaymentRequestStatus);
        }
      });

      dispatch(fetchAllPaymentRequestStatusList(updatedStatusList.length > 0 ? updatedStatusList : undefined));

      dispatch(fetchReloadPaymentRequestsAfterFilter(true));
    }
  };

  const handlePaymentFilterStatusUpdate = (statusCount: number, paymentStatusFilterList?: AllPaymentStatusFilterValue[]) => {
    if (statusCount === 0 || statusCount === MAX_STATUS_COUNT) {
      dispatch(fetchPaymentFilterStatusCount(MAX_STATUS_COUNT));
      dispatch(fetchPaymentFilterStatusList(undefined));
      dispatch(fetchAllPaymentsStatusList(undefined));
      dispatch(fetchAllPaymentsStatusExtendedList(undefined));

      dispatch(fetchReloadPaymentsAfterFilter(true));
    } else {
      dispatch(fetchPaymentFilterStatusCount(statusCount));
      dispatch(fetchPaymentFilterStatusList(paymentStatusFilterList));

      const updatedStatusList: PaymentStatus[] = [];
      const updatedStatusExtendedList: PaymentStatusExtended[] = [];

      paymentStatusFilterList?.forEach(item => {
        if (item.isSelected) {
          if (item.isExtended) {
            updatedStatusExtendedList?.push(item.value as PaymentStatusExtended);
          } else {
            updatedStatusList?.push(item.value as PaymentStatus);
          }
        }
      });

      dispatch(fetchAllPaymentsStatusList(updatedStatusList.length > 0 ? updatedStatusList : undefined));
      dispatch(fetchAllPaymentsStatusExtendedList(updatedStatusExtendedList.length > 0 ? updatedStatusExtendedList : undefined));

      dispatch(fetchReloadPaymentsAfterFilter(true));
    }
  };

  const handlePaymentFilterDateUpdate = (fromDate?: string, toDate?: string, dateOption?: string, reload?: boolean) => {
    dispatch(fetchPaymentFilterDateOption(dateOption));
    dispatch(fetchPaymentFilterFromDate(fromDate));
    dispatch(fetchPaymentFilterToDate(toDate));
    // reload only triggered if status isn't updated else triggered from status updation
    if (reload) dispatch(fetchReloadPaymentsAfterFilter(true));
  };

  const handlePaymentFilterAmountUpdate = (isAmountRange: boolean, fromAmount?: number, toAmount?: number, reload?: boolean) => {
    dispatch(fetchPaymentFilterAmountRange(isAmountRange));
    dispatch(fetchPaymentFilterFromAmount(fromAmount));
    dispatch(fetchPaymentFilterToAmount(toAmount));
    // reload only triggered if status isn't updated else triggered from status updation
    if (reload) dispatch(fetchReloadPaymentsAfterFilter(true));
  };

  const handlePaymentRequestFilterCustomerUpdate = (customer?: CustomerOption) => {
    // Set the state for the update.
    dispatch(fetchPaymentRequestFilterCustomerOption(customer));
    dispatch(fetchReloadPaymentRequestsAfterFilter(true));
  };

  const handlePaymentFilterCustomerUpdate = (customer?: CustomerOption) => {
    // Set the state for the update.
    dispatch(fetchPaymentFilterCustomerOption(customer));
    dispatch(fetchReloadPaymentsAfterFilter(true));
  };

  const handlePaymentFilterPaymentMethodUpdate = (paymentMethod?: PaymentMethodOption) => {
    dispatch(fetchPaymentFilterPaymentMethodOption(paymentMethod));
    dispatch(fetchReloadPaymentsAfterFilter(true));
  };

  const handlePaymentFilterPaymentMethodTypeUpdate = (paymentMethodType?: PaymentMethodType) => {
    dispatch(fetchPaymentFilterPaymentMethodType(paymentMethodType));
    dispatch(fetchReloadPaymentsAfterFilter(true));
  };

  const handleRemovePaymentRequestCustomerFilter = () => {
    handlePaymentRequestFilterCustomerUpdate(undefined);
  };

  const handleRemovePaymentCustomerFilter = () => {
    handlePaymentFilterCustomerUpdate(undefined);
  };

  const handleRemovePaymentMethodFilter = () => {
    handlePaymentFilterPaymentMethodUpdate(undefined);
  };

  const handleRemovePaymentMethodTypeFilter = () => {
    handlePaymentFilterPaymentMethodTypeUpdate(undefined);
  };

  const handleRemovePaymentRequestStatusFilter = (statusIndex: number) => {
    if (paymentRequestFilterStatusList) {
      const updatedStatusList = [...paymentRequestFilterStatusList];
      const updatedItem = { ...updatedStatusList[statusIndex] };
      updatedItem.isSelected = false;
      updatedStatusList[statusIndex] = updatedItem;

      handlePaymentRequestFilterStatusUpdate(paymentRequestFilterStatusCount - 1, updatedStatusList);
    }
  };
  const handleRemovePaymentStatusFilter = (statusIndex: number) => {
    if (paymentFilterStatusList) {
      const updatedStatusList = [...paymentFilterStatusList];
      const updatedItem = { ...updatedStatusList[statusIndex] };
      updatedItem.isSelected = false;
      updatedStatusList[statusIndex] = updatedItem;

      handlePaymentFilterStatusUpdate(paymentFilterStatusCount - 1, updatedStatusList);
    }
  };

  const handleRemovePaymentDateFilter = (reload: boolean) => {
    const fromDate = undefined;
    const toDate = undefined;
    const dateOption = undefined;

    handlePaymentFilterDateUpdate(fromDate, toDate, dateOption, reload);
  };

  const handleRemovePaymentAmountFilter = (reload: boolean) => {
    const fromAmount = undefined;
    const toAmount = undefined;

    handlePaymentFilterAmountUpdate(paymentFilterAmountRange, fromAmount, toAmount, reload);
  };

  const handleRemoveAllPaymentRequestsFilter = () => {
    handleRemovePaymentRequestCustomerFilter();
    // keeping status removal at end so status updation can trigger reload
    handlePaymentRequestFilterStatusUpdate(PR_MAX_STATUS_COUNT);
  };

  const handleRemoveAllPaymentsFilter = () => {
    handleRemovePaymentDateFilter(false);
    handleRemovePaymentAmountFilter(false);
    handleRemovePaymentCustomerFilter();
    handleRemovePaymentMethodFilter();
    handleRemovePaymentMethodTypeFilter();
    // keeping status removal at end so status updation can trigger reload
    handlePaymentFilterStatusUpdate(MAX_STATUS_COUNT);
  };

  return (
    <Box className={classes.rootContainer}>
      <Helmet>
        <title>Aptean Pay Merchant Portal - Home</title>
      </Helmet>
      {/* {Dialogs} */}
      {/*
        Sibling of the refund Dialog, NOT a child of it. MUI unmounts a closed Modal's
        children (keepMounted defaults to false), so nesting this inside a Dialog keyed on
        refundDialogOpen meant it only rendered while the refund dialog was open - and
        nothing sets that flag on the void path, so the dialog never appeared.
      */}
      <VoidPayment
        open={voidDialogOpen}
        paymentRecord={activeVoidPaymentRecord}
        voidStatus={voidStatus}
        voidError={voidError}
        voidErrorReasonCode={voidErrorReasonCode}
        sendVoid={sendVoid}
        clearVoidState={clearVoidState}
        close={handleVoidClose}
        submit={handleVoidSubmit}
        defaultCurrency={defaultCurrency}
      />
      <Dialog
        aria-label={'refund dialog'}
        open={refundDialogOpen}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            // TODO: Potential double handler.
            handleRefundClose();
          }
        }}
        disableEscapeKeyDown
        fullWidth={true}
        maxWidth={'sm'}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <IssueRefund
          close={handleRefundClose}
          paymentRequestRecord={activeRefundPaymentRequestRecord}
          paymentRecord={activeIssueRefundPaymentRecord}
          paymentRecordId={activeIssueRefundPaymentRecord?.id}
          refundStatus={refundStatus}
          sendRefund={sendRefund}
          clearRefundStateStatus={clearRefundStateStatus}
          defaultCurrency={defaultCurrency}
          submit={handleRefundSubmit}
          refundError={refundError}
          clearRefundError={clearRefundError}
          openRequestModal={handleRequestModalViewFromRefund}
          openPaymentModalFromRefund={openPaymentModalFromRefund}
          isCreditMemoEnabled={!!tenantAccount?.settings?.features?.creditMemos?.enabled}
        />
      </Dialog>
      <Dialog
        aria-label={'payment refund dialog'}
        open={paymentRefundDialogOpen}
        onClose={(event, reason) => {
          // TODO: Potential double handler.
          if (reason !== 'backdropClick') {
            handlePaymentRefundClose();
          }
        }}
        disableEscapeKeyDown
        fullWidth={true}
        maxWidth={'sm'}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <IssueRefundPayment
          close={handlePaymentRefundClose}
          paymentRecord={activeRefundPaymentRecord}
          refundStatus={refundStatus}
          sendRefund={sendRefund}
          clearRefundStateStatus={clearRefundStateStatus}
          defaultCurrency={defaultCurrency}
          submit={handlePaymentRefundSubmit}
          openPaymentDetails={handlePaymentDetailsFromRefund}
          isPaymentRefunded={isPartialRefund(activeRefundPaymentRecord)}
          paymentRefundedAmount={calculateRefundedAmount(activeRefundPaymentRecord)}
          refundError={refundError}
          clearRefundError={clearRefundError}
          paymentRequestById={paymentRequestById}
          paymentRequestByIdError={paymentRequestByIdError}
          isFetchingPaymentRequestById={isRefundRequestClicked}
          handleRequestClicked={refundRequestClicked}
          openRequestModalFromRefund={openRequestModalFromRefund}
          isCreditMemoEnabled={!!tenantAccount?.settings?.features?.creditMemos?.enabled}
          isModalOpenedFromPayment={isRefundModalOpenedFromPayment}
        />
      </Dialog>
      <ForwardDialog
        anchorElement={forwardPopOverAnchorElement}
        handleClose={closeForwardDialog}
        handleForward={handleForwardPaymentRequest}
      />
      <PaymentRequestDetails
        open={detailsDialogOpen}
        onClose={handleDetailsClose}
        paymentRecord={activeViewPaymentRequestRecord}
        remind={handlePaymentRemind}
        defaultCurrency={defaultCurrency}
        remindPressed={remindDisabled}
        update={handleUpdatePaymentRequest}
        updatePaymentRequestError={updatePaymentRequestError}
        savePressed={updatePaymentRequestDisabled}
        setSavePressed={setUpdatePaymentRequestDisabled}
        clearUpdatePaymentRequestError={updatePaymentRequestCancel}
        historyDetailClicked={historyDetailClicked}
        openModalFromPaymentHistory={openModalFromPaymentHistory}
        paymentById={paymentById}
        paymentByIdError={paymentByIdError}
        isFetchingPaymentById={isHistoryDetailClicked}
        isCreditMemoEnabled={!!tenantAccount?.settings?.features?.creditMemos?.enabled}
        isClosingRequest={isClosingPaymentRequest}
        setIsClosingRequest={setIsClosingPaymentRequest}
        isCompletingRequest={isCompletingPaymentRequest}
        setIsCompletingRequest={setIsCompletingPaymentRequest}
        closeOrCompleteRequest={handleCloseOrCompleteSubmit}
        isCloseOrCompleteWaiting={isCloseOrCompleteWaiting}
        closeOrCompleteError={closeOrCompleteError}
        clearCloseOrCompleteError={clearCloseOrCompleteError}
        isLoadingRequestAfterUpdate={isLoadingRequestAfterUpdate}
        requestAfterUpdateError={paymentRequestByIdAfterUpdateError}
        canUpdatePaymentRequest={canUpdatePaymentRequest}
        hasPreviewWithNoEmail={hasPreviewWithNoEmail}
      />

      <PaymentDetails
        open={paymentDetailsDialogOpen}
        onClose={handlePaymentDetailsClose}
        refund={handlePaymentRefund}
        paymentRecord={activeViewPaymentRecord}
        defaultCurrency={defaultCurrency}
        invoiceDetailClicked={invoiceDetailClicked}
        invoiceRefundClicked={invoiceRefundClicked}
        openModalFromPaymentRequestInvoice={openModalFromPaymentRequestInvoice}
        paymentRequestById={paymentRequestById}
        paymentRequestByIdError={paymentRequestByIdError}
        isFetchingPaymentRequestById={isInvoiceDetailClicked || isInvoiceRefundClicked}
        isCreditMemoEnabled={!!tenantAccount?.settings?.features?.creditMemos?.enabled}
        handleResendPaymentReceipt={handleResendPaymentReceipt}
        isResendingPaymentReceipt={isResendingPaymentReceipt}
        isPaymentReceiptResent={isPaymentReceiptResent}
        resendPaymentReceiptError={resendPaymentReceiptError}
        canCreateRefund={canCreateRefund}
        canVoidPayment={isVoidAction(activeViewPaymentRecord)}
        voidPayment={handlePaymentVoid}
        isUserReader={isUserReader}
      />
      <ExportPayments
        open={exportDialogOpen}
        onClose={handleExportToggle}
        paymentsReport={paymentsReport}
        paymentsReportError={paymentsReportError}
        handlePaymentsReport={handlePaymentsReport}
        updateExportsCancelledInFlight={updateExportsCancelledInFlight}
        generatingExportsInFlight={generatingExportsInFlight}
        hasActiveFilters={hasActivePaymentFilters}
        filteredCount={paymentConnection?.totalCount ?? undefined}
        filterFromDate={paymentFilterFromDate}
        filterToDate={paymentFilterToDate}
      />
      {/* An export started from the toolbar has no dialog to hold the spinner the dialog would show,
          so the same mask covers the page here while the report is generated. */}
      <LoadingMask loading={directExportInFlight} />

      {/* {export started without the dialog failed} */}
      <Snackbar
        className={matches ? classes.snackBarMobile : classes.snackBar}
        open={!!directExportError}
        autoHideDuration={5000}
        onClose={() => setDirectExportError(undefined)}
        anchorOrigin={anchorOrigin}
      >
        <Alert className={classes.snackBarErrorAlert} icon={false} severity="error">
          <Typography className={classes.errorAlertText}>{directExportError?.message}</Typography>
        </Alert>
      </Snackbar>

      {tenantAccount?.company?.verification?.status === CompanyVerificationStatus.Pending && (
        <AccountPendingBanner
          settingsClickHandler={handleSettingsClick}
          handlePendingBannerClose={handlePendingBannerClose}
          pendingBannerVisible={pendingBannerVisible}
          setHasAdditionalBanner={handleAdditionalBannerChange}
          hasAdditionalBanner={hasAdditionalBanner}
        />
      )}
      {/* {Cannot pay selected requests warning} */}
      <Snackbar
        className={matches ? classes.snackBarMobile : classes.snackBar}
        open={displayPayRequestsError}
        autoHideDuration={5000}
        onClose={() => {
          setDisplayPayRequestsError(false);
        }}
        anchorOrigin={anchorOrigin}
      >
        <Alert color={'warning'} className={classes.snackBarWarningAlert} severity="warning">
          <Typography className={classes.warningAlertText}>{canPayError}</Typography>
        </Alert>
      </Snackbar>

      {/* {Challenge success} */}
      <Snackbar
        className={matches ? classes.snackBarMobile : classes.snackBar}
        open={displayChallengeSuccessful}
        autoHideDuration={5000}
        onClose={() => {
          setDisplayChallengeSuccessful(false);
        }}
        anchorOrigin={anchorOrigin}
      >
        <Alert className={classes.snackBarAlert} icon={<CheckIcon style={{ color: theme.palette.success.dark }} />} severity="success">
          Your challenge has been successfully submitted
        </Alert>
      </Snackbar>

      {/* {payment receipt resent} */}
      <Snackbar
        className={matches ? classes.snackBarMobile : classes.snackBar}
        open={isPaymentReceiptResent && !paymentDetailsDialogOpen && !resendPaymentReceiptError}
        autoHideDuration={5000}
        anchorOrigin={anchorOrigin}
      >
        <Alert className={classes.snackBarAlert} icon={<CheckIcon style={{ color: theme.palette.success.dark }} />} severity="success">
          {`Payment receipt has been sent to ${getSelectedPaymentEmail() || 'the addresses on file'}.`}
        </Alert>
      </Snackbar>

      {/* {payment receipt resent error} */}
      <Snackbar
        className={matches ? classes.snackBarMobile : classes.snackBar}
        open={
          !paymentDetailsDialogOpen &&
          !!resendPaymentReceiptError &&
          resendPaymentReceiptError.graphQLErrors.some(e => e.extensions?.exception.reasonCode === 'RECEIPT_ALREADY_SENT')
        }
        autoHideDuration={5000}
        anchorOrigin={anchorOrigin}
      >
        <Alert className={classes.snackBarWarningAlert} icon={false} severity="warning">
          <Typography className={classes.warningAlertText}>The same payment receipt can only be sent once per 10 minutes.</Typography>
        </Alert>
      </Snackbar>

      {/* {forward payment request resend error} */}
      <Snackbar
        className={matches ? classes.snackBarMobile : classes.snackBar}
        open={!!forwardPaymentRequestError}
        autoHideDuration={5000}
        onClose={() => dispatch(captureForwardPaymentRequestError())}
        anchorOrigin={anchorOrigin}
      >
        <Alert className={classes.snackBarErrorAlert} icon={false} severity="error">
          <Typography className={classes.errorAlertText}>{forwardPaymentRequestError?.message}</Typography>
        </Alert>
      </Snackbar>

      {/* {forward payment request success} */}
      <Snackbar
        className={matches ? classes.snackBarMobile : classes.snackBar}
        open={displayForwardPaymentRequestSuccessful}
        autoHideDuration={5000}
        onClose={() => setDisplayForwardPaymentRequestSuccessful(false)}
        anchorOrigin={anchorOrigin}
      >
        <Alert className={classes.snackBarAlert} icon={<CheckIcon style={{ color: theme.palette.success.dark }} />} severity="success">
          {forwardPaymentRequestSuccessMessage}
        </Alert>
      </Snackbar>

      {/* {payment success} */}
      <Snackbar
        className={matches ? classes.snackBarMobile : classes.snackBar}
        open={displayPaymentSuccessful}
        autoHideDuration={5000}
        onClose={clearCreatePaymentSuccessMessage}
        anchorOrigin={anchorOrigin}
      >
        <Alert className={classes.snackBarAlert} icon={<CheckIcon style={{ color: theme.palette.success.main }} />} severity="success">
          {createPaymentSuccessMessage}
        </Alert>
      </Snackbar>

      {/* Show PTT onboarding banner if the existing merchant has the transition status of REQUESTED */}
      {isTransitioningMerchant && (
        <Alert
          className={classes.snackBarErrorAlert}
          icon={false}
          severity="error"
          sx={{ marginBottom: theme.spacing(1), fontSize: '1rem' }}
        >
          {'To avoid payment disruptions, it is crucial that you complete the '}
          <Link
            variant="body2"
            sx={{ fontWeight: 500, cursor: 'pointer', fontSize: '1rem' }}
            onClick={() => {
              history.push(RoutePath.Onboarding);
            }}
          >
            onboarding form
          </Link>
          {' ASAP. You will not be able to receive payments after the month of March if this is not completed.'}
        </Alert>
      )}

      {/* Dialog reminder for transitioning merchants. */}
      {isTransitioningMerchant && (
        <Dialog
          open={reminderDialogOpen}
          onClose={() => {
            setReminderDialogOpen(false);
          }}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle sx={{ backgroundColor: theme.palette.error.light, color: theme.palette.error.main, fontWeight: 500 }}>
            Action Required
          </DialogTitle>
          <DialogContent sx={{ backgroundColor: theme.palette.error.light }}>
            <DialogContentText sx={{ color: theme.palette.error.main, fontWeight: 500, fontSize: '1rem' }}>
              {
                'To avoid payment disruptions, it is crucial that you complete the onboarding form ASAP. You will not be able to receive payments after the month of March if this is not completed.'
              }
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ backgroundColor: theme.palette.error.light }}>
            <Button
              variant="text"
              onClick={() => {
                setReminderDialogOpen(false);
              }}
            >
              Not Now
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setReminderDialogOpen(false);
                history.push(RoutePath.Onboarding);
              }}
            >
              Take Me There
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Show PTT onboard processing banner if existing merchant has the transition status of PENDING */}
      {tenantAccount?.company?.verification?.transitionStatus === TransitionStatus.Pending &&
        tenantAccount?.payFacType !== PayFac.Ptt && (
          <Alert className={classes.snackBarInfoAlert} icon={false} severity="info" sx={{ marginBottom: theme.spacing(1) }}>
            {'Your application form is being processed, there will be no disruption in service during this time.'}
          </Alert>
        )}

      {/* {Main Content} */}
      <Grid
        container
        wrap={'wrap-reverse'}
        direction="row"
        justifyContent="flex-end"
        alignItems="stretch"
        style={{ flex: 1, minWidth: 0 }}
      >
        <Grid item className={classes.transition} style={{ width: '100%', display: 'flex', minWidth: 0 }}>
          <Paper className={classes.tabs}>
            {pageTitle}
            {<Divider />}
            <TabPanel value={tabValue} index={0} data-cy="payments-panel">
              {/* TODO: Change field/sort/direction to be list specific */}
              <Helmet>
                <title>Aptean Pay Merchant Portal - Payments</title>
              </Helmet>
              <Toolbar className={classes.tabToolbar} variant="dense">
                <Grid alignItems="flex-start" container spacing={1}>
                  {/* Buttons row */}
                  <Grid
                    container
                    item
                    xs={12}
                    md={12}
                    lg={7}
                    xl={9}
                    justifyContent={matchesXsDown ? 'space-around' : 'flex-start'}
                    order={1}
                    wrap="wrap"
                    rowSpacing={2}
                    sx={{ marginTop: 1 }}
                  >
                    <Button
                      size={iconSize}
                      variant={'text'}
                      aria-label={'refresh'}
                      color={'primary'}
                      onClick={handleActiveTabReload}
                      data-cy="refresh"
                      className={classes.toolbarButton}
                    >
                      <RefreshIcon />
                    </Button>

                    {!!tenantAccount?.settings?.features?.payments?.virtualTerminal && (
                      <Button
                        component={RouterLink}
                        startIcon={matchesXsDown ? null : <SvgIcon component={AddIcon} />}
                        size={iconSize}
                        to={'/payment'}
                        variant={'text'}
                        aria-label={'add payment'}
                        color={'primary'}
                        data-cy="add-payment"
                        className={classes.toolbarButton}
                        disabled={isUserReader}
                      >
                        {matchesXsDown ? <SvgIcon component={AddIcon} /> : 'New'}
                      </Button>
                    )}

                    <Button
                      startIcon={matchesXsDown ? null : <InfoIcon />}
                      size={iconSize}
                      variant="text"
                      aria-label={'view details'}
                      disabled={!selectedPayment}
                      color="primary"
                      onClick={() => handlePaymentView(selectedPayment)}
                      data-cy="view-details"
                      className={classes.toolbarButton}
                    >
                      {matchesXsDown ? <InfoIcon /> : 'Details'}
                    </Button>

                    {/*
                      One button, not two. It reads Void while the selected payment can still be reversed
                      for free, and Refund otherwise. With the allowVoid flag off isPaymentVoidable() is
                      always false, so this behaves exactly as it did before the feature.
                    */}
                    <Button
                      startIcon={matchesXsDown ? null : <SvgIcon component={RefundIcon} />}
                      size={iconSize}
                      variant={'text'}
                      aria-label={voidSelected ? 'void' : 'refund'}
                      color={'primary'}
                      disabled={!voidSelected && (!canCreateRefund || !isPaymentRefundable())}
                      onClick={() => (voidSelected ? handlePaymentVoid(selectedPayment) : handlePaymentRefund(selectedPayment, false))}
                      data-cy={voidSelected ? 'void' : 'refund'}
                      className={classes.toolbarButton}
                    >
                      {matchesXsDown ? <SvgIcon component={RefundIcon} /> : reversalActionLabel}
                    </Button>

                    <Button
                      startIcon={matchesXsDown ? null : <ReceiptIcon />}
                      size={iconSize}
                      variant="text"
                      aria-label={'resend receipt'}
                      color="primary"
                      onClick={() => {
                        handleResendPaymentReceipt(selectedPayment?.id);
                      }}
                      data-cy="resend-receipt"
                      className={classes.toolbarButton}
                      disabled={
                        isUserReader ||
                        !selectedPayment ||
                        isResendingPaymentReceipt ||
                        selectedPayment.status !== PaymentStatus.Completed
                      }
                    >
                      {matchesXsDown ? <ReceiptIcon /> : 'Resend Receipt'}
                    </Button>

                    <Button
                      startIcon={matchesXsDown ? null : <SvgIcon component={FileDownloadIcon} />}
                      size={iconSize}
                      variant="text"
                      aria-label={'export'}
                      color="primary"
                      onClick={handleExportClick}
                      disabled={directExportInFlight}
                      data-cy="export-payments"
                      className={classes.toolbarButton}
                    >
                      {matchesXsDown ? <SvgIcon component={FileDownloadIcon} /> : 'Export'}
                    </Button>

                    <Button
                      startIcon={matchesXsDown ? null : <ViewColumnIcon />}
                      size={iconSize}
                      variant="text"
                      aria-label={'show columns'}
                      color="primary"
                      onClick={() => paymentsGridApi.current?.showPreferences(GridPreferencePanelsValue.columns)}
                      data-cy="show-columns"
                      className={classes.toolbarButton}
                    >
                      {matchesXsDown ? <ViewColumnIcon /> : 'Columns'}
                    </Button>
                  </Grid>

                  {/* Search & Filters */}
                  <Grid
                    container
                    item
                    wrap="nowrap"
                    xs={12}
                    md={12}
                    lg={5}
                    xl={3}
                    justifyContent="flex-end"
                    alignItems="center"
                    alignContent="center"
                    columnSpacing={2}
                    order={2}
                    sx={{ marginTop: 1 }}
                  >
                    <Grid item>
                      <SearchBar
                        placeholderText={'Search payments'}
                        tooltipText={'Search by Payment ID, Customer PO Number, Invoice Number, Order Number or Description'}
                        queryString={paymentQueryString}
                        updateQueryString={updatePaymentQueryString}
                        minimumCharacter={3}
                        searchError={searchError}
                        clearSearchError={clearPaymentSearchError}
                        isSearchDisabled={tabValue !== 0}
                        isSpacesAllowed={true}
                        searchName={'payments'}
                      />
                    </Grid>
                    <Grid item flexShrink={0}>
                      <PaymentsListFilter
                        totalCount={paymentConnection?.totalCount}
                        defaultCurrency={defaultCurrency}
                        filterDateOption={paymentFilterDateOption}
                        filterFromDate={paymentFilterFromDate}
                        filterToDate={paymentFilterToDate}
                        filterAmountRange={paymentFilterAmountRange}
                        filterFromAmount={paymentFilterFromAmount}
                        filterToAmount={paymentFilterToAmount}
                        filterStatusCount={paymentFilterStatusCount}
                        filterPaymentStatusList={paymentFilterStatusList}
                        filterCustomer={paymentFilterCustomerOption}
                        handleFilterStatusUpdate={handlePaymentFilterStatusUpdate}
                        handleFilterAmountUpdate={handlePaymentFilterAmountUpdate}
                        handleFilterDateUpdate={handlePaymentFilterDateUpdate}
                        handleFilterCustomerUpdate={handlePaymentFilterCustomerUpdate}
                        handleFilterPaymentMethodUpdate={handlePaymentFilterPaymentMethodUpdate}
                        filterPaymentMethod={paymentFilterPaymentMethodOption}
                        handleFilterPaymentMethodTypeUpdate={handlePaymentFilterPaymentMethodTypeUpdate}
                        filterPaymentMethodType={paymentFilterPaymentMethodType}
                        resourceId={tenantId ?? ''}
                        customersEnabled={!!tenantAccount?.settings?.features?.customers?.enabled}
                        achEnabled={!!tenantAccount?.settings?.supportedPaymentMethods?.includes(PaymentMethodType.PaymentBankUs)}
                        cardEnabled={!!tenantAccount?.settings?.supportedPaymentMethods?.includes(PaymentMethodType.CreditCard)}
                        hasCustomerOptionError={Boolean(customerOptionError)}
                      />
                    </Grid>
                  </Grid>
                  <Grid container item xs={12} style={{ paddingTop: 0, paddingBottom: 0 }} order={3}>
                    <PaymentsListFilterChips
                      isLoadingPayments={isLoadingPayments}
                      defaultCurrency={defaultCurrency}
                      filterDateOption={paymentFilterDateOption}
                      filterFromDate={paymentFilterFromDate}
                      filterToDate={paymentFilterToDate}
                      filterAmountRange={paymentFilterAmountRange}
                      filterFromAmount={paymentFilterFromAmount}
                      filterToAmount={paymentFilterToAmount}
                      filterStatusCount={paymentFilterStatusCount}
                      filterPaymentStatusList={paymentFilterStatusList}
                      filterCustomerOption={paymentFilterCustomerOption}
                      filterPaymentMethodOption={paymentFilterPaymentMethodOption}
                      filterPaymentMethodType={paymentFilterPaymentMethodType}
                      removePaymentMethodTypeFilter={handleRemovePaymentMethodTypeFilter}
                      removeAllPaymentsFilter={handleRemoveAllPaymentsFilter}
                      removeAmountRange={handleRemovePaymentAmountFilter}
                      removeDateRange={handleRemovePaymentDateFilter}
                      removeStatusFilter={handleRemovePaymentStatusFilter}
                      removeCustomerFilter={handleRemovePaymentCustomerFilter}
                      removePaymentMethodFilter={handleRemovePaymentMethodFilter}
                    />
                  </Grid>
                </Grid>
              </Toolbar>
              {paymentConnection && (
                <PaymentsList
                  loadPage={loadPaymentsPage}
                  handleViewPayment={handlePaymentView}
                  setSelectedRecord={setSelectedPayment}
                  selectedRecord={selectedPayment}
                  defaultCurrency={defaultCurrency}
                  paymentConnection={paymentConnection}
                  payments={payments}
                  direction={paymentDirection}
                  field={paymentField}
                  handleSort={handlePaymentSort}
                  isLoadingPayments={isLoadingPayments}
                  isCreditMemoEnabled={!!tenantAccount?.settings?.features?.creditMemos?.enabled}
                  isCustomerEnabled={!!tenantAccount?.settings?.features?.customers?.enabled}
                  gridApiRef={paymentsGridApi}
                  isConvenienceFeeEnabled={!!tenantAccount?.settings?.features?.payments?.convenienceFees}
                />
              )}
            </TabPanel>
            <TabPanel value={tabValue} index={1} data-cy="payment-requests-panel">
              <Helmet>
                <title>Aptean Pay Merchant Portal - Payment Requests</title>
              </Helmet>
              {/* TODO: Change field/sort/direction to be list specific */}
              <Toolbar className={classes.tabToolbar} variant="dense">
                <Grid alignItems="flex-start" container spacing={1}>
                  {/* Buttons row */}
                  <Grid
                    container
                    item
                    xs={12}
                    md={12}
                    lg={7}
                    xl={9}
                    justifyContent={matchesXsDown ? 'space-around' : 'flex-start'}
                    order={1}
                    wrap="wrap"
                    rowSpacing={2}
                    sx={{ marginTop: 1 }}
                  >
                    <Button
                      size={iconSize}
                      variant={'text'}
                      aria-label={'refresh'}
                      color={'primary'}
                      onClick={handleActiveTabReload}
                      data-cy="refresh"
                      className={classes.toolbarButton}
                    >
                      {<RefreshIcon />}
                    </Button>

                    <Button
                      startIcon={matchesXsDown ? null : <SvgIcon component={AddIcon} />}
                      size={iconSize}
                      variant={'text'}
                      aria-label={'add payment request'}
                      disabled={!canCreatePaymentRequest || hasPreviewWithNoEmail}
                      color={'primary'}
                      onClick={handleAddPaymentRequestOpen}
                      data-cy="add-payment-request"
                      className={classes.toolbarButton}
                    >
                      {matchesXsDown ? <SvgIcon component={AddIcon} /> : 'New'}
                    </Button>

                    {!!tenantAccount?.settings?.features?.payments?.virtualTerminal && (
                      <Button
                        startIcon={matchesXsDown ? null : <SvgIcon component={CreditCardIcon} />}
                        size={iconSize}
                        variant={'text'}
                        aria-label={'add payment'}
                        color={canPaySelectedRequests ? 'primary' : 'warning'}
                        onClick={handlePaymentTerminalOpenFromRequest}
                        data-cy="add-payment"
                        className={classes.toolbarButton}
                        disabled={!selectedPaymentRequests || !selectedPaymentRequests.length || isUserReader}
                      >
                        {matchesXsDown ? <SvgIcon component={CreditCardIcon} /> : 'Pay'}
                      </Button>
                    )}

                    <Button
                      startIcon={matchesXsDown ? null : <InfoIcon />}
                      size={iconSize}
                      variant="text"
                      aria-label={'view details'}
                      disabled={!selectedPaymentRequests || selectedPaymentRequests.length !== 1}
                      color="primary"
                      onClick={() => {
                        if (selectedPaymentRequests && selectedPaymentRequests.length === 1) {
                          handlePaymentRequestView(selectedPaymentRequests[0]);
                        }
                      }}
                      data-cy="view-details"
                      className={classes.toolbarButton}
                    >
                      {matchesXsDown ? <InfoIcon /> : 'Details'}
                    </Button>

                    <Button
                      startIcon={matchesXsDown ? null : <MailIcon />}
                      size={iconSize}
                      variant="text"
                      aria-label="send"
                      color="primary"
                      disabled={
                        !canUpdatePaymentRequest ||
                        hasPreviewWithNoEmail ||
                        !canSendRequestCommunicationFromMenu ||
                        remindDisabled ||
                        isRemindPaymentRequestsInFlight
                      }
                      onClick={() => {
                        handlePaymentRequestsRemindFromMenu(selectedPaymentRequests);
                      }}
                      data-cy="remind"
                      className={classes.toolbarButton}
                    >
                      {matchesXsDown ? <MailIcon /> : 'Send'}
                    </Button>

                    <Button
                      startIcon={matchesXsDown ? null : <SvgIcon component={CloseIcon} />}
                      size={iconSize}
                      variant={'text'}
                      aria-label={'close'}
                      disabled={!(canUpdatePaymentRequest && tabValue === 1 && canCloseRequestFromMenu)}
                      color={'primary'}
                      onClick={() => {
                        if (selectedPaymentRequests && selectedPaymentRequests.length === 1) {
                          handlePaymentRequestClose(selectedPaymentRequests[0]);
                        }
                      }}
                      data-cy="close"
                      className={classes.toolbarButton}
                    >
                      {matchesXsDown ? <SvgIcon component={CloseIcon} /> : 'Close'}
                    </Button>
                    <Button
                      startIcon={matchesXsDown ? null : <SvgIcon component={ForwardToInbox} />}
                      size={iconSize}
                      disabled={!canForwardPaymentRequest || !selectedPaymentRequests?.length || selectedPaymentRequests?.length > 1}
                      onClick={openForwardDialog}
                      variant="text"
                      aria-label="forward"
                      data-cy="forward"
                      color="primary"
                      className={classes.toolbarButton}
                    >
                      {matchesXsDown ? <SvgIcon component={ForwardToInbox} /> : 'Forward'}
                    </Button>

                    <Button
                      startIcon={matchesXsDown ? null : <ViewColumnIcon />}
                      size={iconSize}
                      variant="text"
                      aria-label={'show columns'}
                      color="primary"
                      onClick={() => paymentRequestsGridApi.current?.showPreferences(GridPreferencePanelsValue.columns)}
                      data-cy="show-columns-requests"
                      className={classes.toolbarButton}
                    >
                      {matchesXsDown ? <ViewColumnIcon /> : 'Columns'}
                    </Button>
                  </Grid>

                  {/* Search & Filters */}
                  <Grid
                    container
                    item
                    wrap="nowrap"
                    xs={12}
                    md={12}
                    lg={5}
                    xl={3}
                    justifyContent="flex-end"
                    alignContent="center"
                    alignItems="center"
                    columnSpacing={2}
                    order={2}
                    sx={{ marginTop: 1 }}
                  >
                    <Grid item>
                      <SearchBar
                        placeholderText={'Search requests'}
                        tooltipText={'Search by Reference #'}
                        queryString={paymentRequestQueryString}
                        updateQueryString={updatePaymentRequestQueryString}
                        minimumCharacter={3}
                        searchError={searchError}
                        clearSearchError={clearPaymentRequestSearchError}
                        isSearchDisabled={tabValue !== 1}
                        isSpacesAllowed={false}
                        searchName={'payment-requests'}
                      />
                    </Grid>
                    <Grid item>
                      <PaymentRequestListFilter
                        totalCount={payRequestConnection?.totalCount}
                        filterStatusCount={paymentRequestFilterStatusCount}
                        filterPaymentRequestStatusList={paymentRequestFilterStatusList}
                        filterCustomer={paymentRequestFilterCustomerOption}
                        handleFilterStatusUpdate={handlePaymentRequestFilterStatusUpdate}
                        handleFilterCustomerUpdate={handlePaymentRequestFilterCustomerUpdate}
                        customersEnabled={!!tenantAccount?.settings?.features?.customers?.enabled}
                        hasCustomerOptionError={Boolean(customerOptionError)}
                      />
                    </Grid>
                  </Grid>
                  <Grid container item xs={12} style={{ paddingTop: 0, paddingBottom: 0 }} order={3}>
                    <PaymentRequestListFilterChips
                      isLoadingPayments={isLoadingPaymentRequests}
                      filterStatusCount={paymentRequestFilterStatusCount}
                      filterPaymentStatusList={paymentRequestFilterStatusList}
                      filterCustomerOption={paymentRequestFilterCustomerOption}
                      removeAllPaymentsFilter={handleRemoveAllPaymentRequestsFilter}
                      removeStatusFilter={handleRemovePaymentRequestStatusFilter}
                      removeCustomerFilter={handleRemovePaymentRequestCustomerFilter}
                    />
                  </Grid>
                </Grid>
              </Toolbar>
              {payRequestConnection && (
                <PaymentRequestList
                  loadPage={loadPaymentRequestsPage}
                  handleViewPaymentRequest={handlePaymentRequestView}
                  handleSelectedRecordsChange={handleSelectedPaymentRequestsChange}
                  defaultCurrency={defaultCurrency}
                  paymentRequestConnection={payRequestConnection}
                  paymentRequests={paymentRequests}
                  direction={paymentRequestDirection}
                  field={paymentRequestField}
                  handleSort={handlePaymentRequestSort}
                  isLoadingPaymentRequests={isLoadingPaymentRequests}
                  gridApiRef={paymentRequestsGridApi}
                  isRemindFromMenuInFlight={isRemindPaymentRequestsInFlight}
                  isCustomerEnabled={!!tenantAccount?.settings?.features?.customers?.enabled}
                />
              )}
            </TabPanel>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Home;
